var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import require$$0, { useMemo, useCallback, useEffect, useRef } from "react";
import create from "zustand";
import { useMapStore } from "@hyperobjekt/mapgl";
import { useQuery, QueryClient, QueryClientProvider } from "react-query";
import { getScale, getPositionScale } from "@hyperobjekt/scales";
/*!
 * mustache.js - Logic-less {{mustache}} templates with JavaScript
 * http://github.com/janl/mustache.js
 */
var objectToString = Object.prototype.toString;
var isArray = Array.isArray || function isArrayPolyfill(object) {
  return objectToString.call(object) === "[object Array]";
};
function isFunction(object) {
  return typeof object === "function";
}
function typeStr(obj) {
  return isArray(obj) ? "array" : typeof obj;
}
function escapeRegExp(string) {
  return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function hasProperty(obj, propName) {
  return obj != null && typeof obj === "object" && propName in obj;
}
function primitiveHasOwnProperty(primitive, propName) {
  return primitive != null && typeof primitive !== "object" && primitive.hasOwnProperty && primitive.hasOwnProperty(propName);
}
var regExpTest = RegExp.prototype.test;
function testRegExp(re2, string) {
  return regExpTest.call(re2, string);
}
var nonSpaceRe = /\S/;
function isWhitespace(string) {
  return !testRegExp(nonSpaceRe, string);
}
var entityMap = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;",
  "`": "&#x60;",
  "=": "&#x3D;"
};
function escapeHtml(string) {
  return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap(s) {
    return entityMap[s];
  });
}
var whiteRe = /\s*/;
var spaceRe = /\s+/;
var equalsRe = /\s*=/;
var curlyRe = /\s*\}/;
var tagRe = /#|\^|\/|>|\{|&|=|!/;
function parseTemplate(template, tags) {
  if (!template)
    return [];
  var lineHasNonSpace = false;
  var sections = [];
  var tokens = [];
  var spaces = [];
  var hasTag = false;
  var nonSpace = false;
  var indentation = "";
  var tagIndex = 0;
  function stripSpace() {
    if (hasTag && !nonSpace) {
      while (spaces.length)
        delete tokens[spaces.pop()];
    } else {
      spaces = [];
    }
    hasTag = false;
    nonSpace = false;
  }
  var openingTagRe, closingTagRe, closingCurlyRe;
  function compileTags(tagsToCompile) {
    if (typeof tagsToCompile === "string")
      tagsToCompile = tagsToCompile.split(spaceRe, 2);
    if (!isArray(tagsToCompile) || tagsToCompile.length !== 2)
      throw new Error("Invalid tags: " + tagsToCompile);
    openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + "\\s*");
    closingTagRe = new RegExp("\\s*" + escapeRegExp(tagsToCompile[1]));
    closingCurlyRe = new RegExp("\\s*" + escapeRegExp("}" + tagsToCompile[1]));
  }
  compileTags(tags || mustache.tags);
  var scanner = new Scanner(template);
  var start, type, value, chr, token, openSection;
  while (!scanner.eos()) {
    start = scanner.pos;
    value = scanner.scanUntil(openingTagRe);
    if (value) {
      for (var i = 0, valueLength = value.length; i < valueLength; ++i) {
        chr = value.charAt(i);
        if (isWhitespace(chr)) {
          spaces.push(tokens.length);
          indentation += chr;
        } else {
          nonSpace = true;
          lineHasNonSpace = true;
          indentation += " ";
        }
        tokens.push(["text", chr, start, start + 1]);
        start += 1;
        if (chr === "\n") {
          stripSpace();
          indentation = "";
          tagIndex = 0;
          lineHasNonSpace = false;
        }
      }
    }
    if (!scanner.scan(openingTagRe))
      break;
    hasTag = true;
    type = scanner.scan(tagRe) || "name";
    scanner.scan(whiteRe);
    if (type === "=") {
      value = scanner.scanUntil(equalsRe);
      scanner.scan(equalsRe);
      scanner.scanUntil(closingTagRe);
    } else if (type === "{") {
      value = scanner.scanUntil(closingCurlyRe);
      scanner.scan(curlyRe);
      scanner.scanUntil(closingTagRe);
      type = "&";
    } else {
      value = scanner.scanUntil(closingTagRe);
    }
    if (!scanner.scan(closingTagRe))
      throw new Error("Unclosed tag at " + scanner.pos);
    if (type == ">") {
      token = [type, value, start, scanner.pos, indentation, tagIndex, lineHasNonSpace];
    } else {
      token = [type, value, start, scanner.pos];
    }
    tagIndex++;
    tokens.push(token);
    if (type === "#" || type === "^") {
      sections.push(token);
    } else if (type === "/") {
      openSection = sections.pop();
      if (!openSection)
        throw new Error('Unopened section "' + value + '" at ' + start);
      if (openSection[1] !== value)
        throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
    } else if (type === "name" || type === "{" || type === "&") {
      nonSpace = true;
    } else if (type === "=") {
      compileTags(value);
    }
  }
  stripSpace();
  openSection = sections.pop();
  if (openSection)
    throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);
  return nestTokens(squashTokens(tokens));
}
function squashTokens(tokens) {
  var squashedTokens = [];
  var token, lastToken;
  for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
    token = tokens[i];
    if (token) {
      if (token[0] === "text" && lastToken && lastToken[0] === "text") {
        lastToken[1] += token[1];
        lastToken[3] = token[3];
      } else {
        squashedTokens.push(token);
        lastToken = token;
      }
    }
  }
  return squashedTokens;
}
function nestTokens(tokens) {
  var nestedTokens = [];
  var collector = nestedTokens;
  var sections = [];
  var token, section;
  for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
    token = tokens[i];
    switch (token[0]) {
      case "#":
      case "^":
        collector.push(token);
        sections.push(token);
        collector = token[4] = [];
        break;
      case "/":
        section = sections.pop();
        section[5] = token[2];
        collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
        break;
      default:
        collector.push(token);
    }
  }
  return nestedTokens;
}
function Scanner(string) {
  this.string = string;
  this.tail = string;
  this.pos = 0;
}
Scanner.prototype.eos = function eos() {
  return this.tail === "";
};
Scanner.prototype.scan = function scan(re2) {
  var match = this.tail.match(re2);
  if (!match || match.index !== 0)
    return "";
  var string = match[0];
  this.tail = this.tail.substring(string.length);
  this.pos += string.length;
  return string;
};
Scanner.prototype.scanUntil = function scanUntil(re2) {
  var index = this.tail.search(re2), match;
  switch (index) {
    case -1:
      match = this.tail;
      this.tail = "";
      break;
    case 0:
      match = "";
      break;
    default:
      match = this.tail.substring(0, index);
      this.tail = this.tail.substring(index);
  }
  this.pos += match.length;
  return match;
};
function Context(view, parentContext) {
  this.view = view;
  this.cache = { ".": this.view };
  this.parent = parentContext;
}
Context.prototype.push = function push(view) {
  return new Context(view, this);
};
Context.prototype.lookup = function lookup(name) {
  var cache = this.cache;
  var value;
  if (cache.hasOwnProperty(name)) {
    value = cache[name];
  } else {
    var context = this, intermediateValue, names, index, lookupHit = false;
    while (context) {
      if (name.indexOf(".") > 0) {
        intermediateValue = context.view;
        names = name.split(".");
        index = 0;
        while (intermediateValue != null && index < names.length) {
          if (index === names.length - 1)
            lookupHit = hasProperty(intermediateValue, names[index]) || primitiveHasOwnProperty(intermediateValue, names[index]);
          intermediateValue = intermediateValue[names[index++]];
        }
      } else {
        intermediateValue = context.view[name];
        lookupHit = hasProperty(context.view, name);
      }
      if (lookupHit) {
        value = intermediateValue;
        break;
      }
      context = context.parent;
    }
    cache[name] = value;
  }
  if (isFunction(value))
    value = value.call(this.view);
  return value;
};
function Writer() {
  this.templateCache = {
    _cache: {},
    set: function set(key, value) {
      this._cache[key] = value;
    },
    get: function get(key) {
      return this._cache[key];
    },
    clear: function clear() {
      this._cache = {};
    }
  };
}
Writer.prototype.clearCache = function clearCache() {
  if (typeof this.templateCache !== "undefined") {
    this.templateCache.clear();
  }
};
Writer.prototype.parse = function parse(template, tags) {
  var cache = this.templateCache;
  var cacheKey = template + ":" + (tags || mustache.tags).join(":");
  var isCacheEnabled = typeof cache !== "undefined";
  var tokens = isCacheEnabled ? cache.get(cacheKey) : void 0;
  if (tokens == void 0) {
    tokens = parseTemplate(template, tags);
    isCacheEnabled && cache.set(cacheKey, tokens);
  }
  return tokens;
};
Writer.prototype.render = function render(template, view, partials, config) {
  var tags = this.getConfigTags(config);
  var tokens = this.parse(template, tags);
  var context = view instanceof Context ? view : new Context(view, void 0);
  return this.renderTokens(tokens, context, partials, template, config);
};
Writer.prototype.renderTokens = function renderTokens(tokens, context, partials, originalTemplate, config) {
  var buffer = "";
  var token, symbol, value;
  for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
    value = void 0;
    token = tokens[i];
    symbol = token[0];
    if (symbol === "#")
      value = this.renderSection(token, context, partials, originalTemplate, config);
    else if (symbol === "^")
      value = this.renderInverted(token, context, partials, originalTemplate, config);
    else if (symbol === ">")
      value = this.renderPartial(token, context, partials, config);
    else if (symbol === "&")
      value = this.unescapedValue(token, context);
    else if (symbol === "name")
      value = this.escapedValue(token, context, config);
    else if (symbol === "text")
      value = this.rawValue(token);
    if (value !== void 0)
      buffer += value;
  }
  return buffer;
};
Writer.prototype.renderSection = function renderSection(token, context, partials, originalTemplate, config) {
  var self = this;
  var buffer = "";
  var value = context.lookup(token[1]);
  function subRender(template) {
    return self.render(template, context, partials, config);
  }
  if (!value)
    return;
  if (isArray(value)) {
    for (var j = 0, valueLength = value.length; j < valueLength; ++j) {
      buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate, config);
    }
  } else if (typeof value === "object" || typeof value === "string" || typeof value === "number") {
    buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate, config);
  } else if (isFunction(value)) {
    if (typeof originalTemplate !== "string")
      throw new Error("Cannot use higher-order sections without the original template");
    value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);
    if (value != null)
      buffer += value;
  } else {
    buffer += this.renderTokens(token[4], context, partials, originalTemplate, config);
  }
  return buffer;
};
Writer.prototype.renderInverted = function renderInverted(token, context, partials, originalTemplate, config) {
  var value = context.lookup(token[1]);
  if (!value || isArray(value) && value.length === 0)
    return this.renderTokens(token[4], context, partials, originalTemplate, config);
};
Writer.prototype.indentPartial = function indentPartial(partial, indentation, lineHasNonSpace) {
  var filteredIndentation = indentation.replace(/[^ \t]/g, "");
  var partialByNl = partial.split("\n");
  for (var i = 0; i < partialByNl.length; i++) {
    if (partialByNl[i].length && (i > 0 || !lineHasNonSpace)) {
      partialByNl[i] = filteredIndentation + partialByNl[i];
    }
  }
  return partialByNl.join("\n");
};
Writer.prototype.renderPartial = function renderPartial(token, context, partials, config) {
  if (!partials)
    return;
  var tags = this.getConfigTags(config);
  var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
  if (value != null) {
    var lineHasNonSpace = token[6];
    var tagIndex = token[5];
    var indentation = token[4];
    var indentedValue = value;
    if (tagIndex == 0 && indentation) {
      indentedValue = this.indentPartial(value, indentation, lineHasNonSpace);
    }
    var tokens = this.parse(indentedValue, tags);
    return this.renderTokens(tokens, context, partials, indentedValue, config);
  }
};
Writer.prototype.unescapedValue = function unescapedValue(token, context) {
  var value = context.lookup(token[1]);
  if (value != null)
    return value;
};
Writer.prototype.escapedValue = function escapedValue(token, context, config) {
  var escape = this.getConfigEscape(config) || mustache.escape;
  var value = context.lookup(token[1]);
  if (value != null)
    return typeof value === "number" && escape === mustache.escape ? String(value) : escape(value);
};
Writer.prototype.rawValue = function rawValue(token) {
  return token[1];
};
Writer.prototype.getConfigTags = function getConfigTags(config) {
  if (isArray(config)) {
    return config;
  } else if (config && typeof config === "object") {
    return config.tags;
  } else {
    return void 0;
  }
};
Writer.prototype.getConfigEscape = function getConfigEscape(config) {
  if (config && typeof config === "object" && !isArray(config)) {
    return config.escape;
  } else {
    return void 0;
  }
};
var mustache = {
  name: "mustache.js",
  version: "4.2.0",
  tags: ["{{", "}}"],
  clearCache: void 0,
  escape: void 0,
  parse: void 0,
  render: void 0,
  Scanner: void 0,
  Context: void 0,
  Writer: void 0,
  set templateCache(cache) {
    defaultWriter.templateCache = cache;
  },
  get templateCache() {
    return defaultWriter.templateCache;
  }
};
var defaultWriter = new Writer();
mustache.clearCache = function clearCache2() {
  return defaultWriter.clearCache();
};
mustache.parse = function parse2(template, tags) {
  return defaultWriter.parse(template, tags);
};
mustache.render = function render2(template, view, partials, config) {
  if (typeof template !== "string") {
    throw new TypeError('Invalid template! Template should be a "string" but "' + typeStr(template) + '" was given as the first argument for mustache#render(template, view, partials)');
  }
  return defaultWriter.render(template, view, partials, config);
};
mustache.escape = escapeHtml;
mustache.Scanner = Scanner;
mustache.Context = Context;
mustache.Writer = Writer;
const loadLanguage = async (language, url) => {
  if (typeof language !== "string")
    throw new Error("Language must be a string identifier");
  if (typeof url === "object")
    return Promise.resolve(url);
  if (typeof url !== "string")
    throw new Error("URL must be a string");
  const isCsv = url.endsWith(".csv");
  return fetch(url).then((response) => isCsv ? response.text() : response.json()).then((data) => {
    if (!isCsv)
      return data;
    return data.reduce((dict, row) => {
      const { key, value } = row;
      dict[key] = value;
      return dict;
    }, {});
  });
};
function interpolateString(template, values) {
  const matches = template.match(/{{[^}]+}}/g) || [];
  const matchKeys = matches.map((match) => match.replace(/[{}]/g, ""));
  const valueKeys = Object.keys(values);
  const missingKeys = matchKeys.filter((key) => !valueKeys.includes(key));
  if (missingKeys.length > 0)
    console.warn("Missing values for interpolation:", missingKeys);
  return mustache.render(template, values);
}
const useLangStore = create((set, get) => ({
  language: "en",
  setLanguage: (language, dict) => {
    if (typeof language !== "string")
      throw new Error("Language must be a string identifier");
    const result = {};
    result["language"] = language;
    if (typeof dict === "object")
      result["dict"] = __spreadProps(__spreadValues({}, get().dict), { [language]: dict });
    set(result);
  },
  dict: { en: {} },
  setLanguageDict: (dict) => set({ dict }),
  loadLanguageDict: async (language, url, activate = false) => {
    const langDictionary = await loadLanguage(language, url);
    console.debug(`loaded '${language}' language dictionary`, langDictionary);
    const updates = {};
    updates["dict"] = __spreadProps(__spreadValues({}, get().dict), { [language]: langDictionary });
    if (activate)
      updates["language"] = language;
    if (!get().ready)
      updates["ready"] = true;
    set(updates);
    return langDictionary;
  },
  ready: false,
  set
}));
function useLang(keys, context) {
  const [language, dict] = useLangStore((state) => [
    state.language,
    state.dict
  ]);
  return useMemo(() => {
    if (Array.isArray(keys) && keys.length === 0)
      return [];
    const mapKeys = typeof keys === "string" ? [keys] : keys;
    const lang = dict[language];
    const values = mapKeys.map((key) => {
      key = key.toUpperCase();
      if (!lang[key]) {
        return "";
      }
      if (!context)
        return lang[key];
      return interpolateString(lang[key], context);
    });
    return values.length === 1 ? values[0] : values;
  }, [keys, language, dict, context]);
}
function useLangObject(ids, { prefix = "", context } = {}) {
  if (typeof ids === "string")
    ids = [ids];
  const langKeys = ids.map((id) => {
    return `${(prefix || "") + id}`.toUpperCase();
  });
  const langEntries = useLang(langKeys, context);
  const langArray = typeof langEntries === "string" ? [langEntries] : langEntries;
  return langArray.reduce((lang, entry, idx) => {
    lang[ids[idx]] = entry;
    return lang;
  }, {});
}
function useLoadLanguage() {
  return useLangStore((state) => state.loadLanguageDict);
}
function useSetLanguage() {
  return useLangStore((state) => state.setLanguage);
}
function useLoadConfig() {
  const loadConfig2 = useConfigStore((state) => state.loadConfig);
  const loadLanguageDict = useLangStore((state) => state.loadLanguageDict);
  return useCallback((config) => {
    const _a = config, { lang = {} } = _a, configEntries = __objRest(_a, ["lang"]);
    const configPromises = Object.keys(configEntries).map((key) => {
      const entry = config[key];
      return loadConfig2(key, entry);
    });
    const langPromises = Object.keys(lang).map((key) => {
      const url = lang[key];
      return loadLanguageDict(key, url).then((dict) => {
        return {
          type: "lang",
          lang: key,
          dict
        };
      });
    });
    return Promise.all([configPromises, langPromises].flat()).then((configs) => {
      return configs.reduce((acc, config2) => {
        if (!config2 || !config2.type)
          return acc;
        if (config2.type === "lang" && !acc["lang"]) {
          acc["lang"] = {};
          acc["lang"][config2.lang] = config2.dict;
          return acc;
        }
        acc[config2.type] = config2.config;
        return acc;
      }, {});
    });
  }, [loadConfig2, loadLanguageDict]);
}
function useConfig(id) {
  return useConfigStore((state) => state[id]);
}
const DEFAULT_VARMAP = {
  choroplethMetric: "c",
  bubbleMetric: "b",
  subgroup: "s",
  region: "r",
  year: "y",
  zoom: "z",
  latitude: "lat",
  longitude: "lon",
  locations: "l",
  lang: "lang"
};
const useRouteStore = create((set) => ({
  varMap: DEFAULT_VARMAP,
  setVarMap: (varMap) => set({ varMap }),
  queryParams: {},
  setQueryParams: (queryParams) => set({ queryParams }),
  set
}));
function getCurrentUrlQueryParams() {
  var _a;
  if (!((_a = window == null ? void 0 : window.location) == null ? void 0 : _a.search))
    return new URLSearchParams();
  return Object.fromEntries(new URLSearchParams(window.location.search));
}
function setUrlQueryParams(values) {
  var _a, _b;
  const queryParams = new URLSearchParams(values);
  const paramString = queryParams.toString();
  const newValue = `${(_a = window == null ? void 0 : window.location) == null ? void 0 : _a.pathname}?${paramString}`;
  (_b = window == null ? void 0 : window.history) == null ? void 0 : _b.replaceState({}, "", newValue);
}
const _mapFeaturesToString = (features) => {
  if (!Array.isArray(features) || features.length === 0)
    return void 0;
  return features.filter((f2) => {
    var _a;
    return Boolean((_a = f2.properties) == null ? void 0 : _a.GEOID);
  }).map((f2) => f2.properties.GEOID).join("-");
};
const mapStateToQueryParams = ({
  state = {},
  varMap,
  mapFeaturesToString = _mapFeaturesToString
} = {}) => {
  var _b;
  const _a = state, { locations } = _a, newState = __objRest(_a, ["locations"]);
  if ((_b = state.locations) == null ? void 0 : _b.length)
    newState["locations"] = mapFeaturesToString(state.locations);
  return Object.keys(newState).reduce((acc, key) => {
    const value = newState[key];
    if (value) {
      acc[varMap[key] || key] = value;
    }
    return acc;
  }, {});
};
const reverseVarMap = (varMap) => {
  return Object.keys(varMap).reduce((acc, key) => {
    acc[varMap[key]] = key;
    return acc;
  }, {});
};
const mapParamsToStateValues = (params, varMap) => {
  const reversedVarMap = reverseVarMap(varMap);
  return Object.keys(params).reduce((acc, key) => {
    const stateKey = reversedVarMap[key] || key;
    acc[stateKey] = params[key];
    return acc;
  }, {});
};
function useCurrentRouteParams() {
  const params = getCurrentUrlQueryParams();
  const varMap = useRouteStore((state) => state.varMap);
  const result = mapParamsToStateValues(params, varMap);
  return result;
}
var propTypes = { exports: {} };
var ReactPropTypesSecret$1 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;
var ReactPropTypesSecret = ReactPropTypesSecret_1;
function emptyFunction() {
}
function emptyFunctionWithReset() {
}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      return;
    }
    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
    err.name = "Invariant Violation";
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
{
  propTypes.exports = factoryWithThrowingShims();
}
var PropTypes = propTypes.exports;
function shallow(objA, objB) {
  if (Object.is(objA, objB)) {
    return true;
  }
  if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) {
    return false;
  }
  const keysA = Object.keys(objA);
  if (keysA.length !== Object.keys(objB).length) {
    return false;
  }
  for (let i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !Object.is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }
  return true;
}
const useDashboardStore = create((set) => ({
  choroplethMetric: null,
  setChoroplethMetric: (choroplethMetric) => set({ choroplethMetric }),
  bubbleMetric: null,
  setBubbleMetric: (bubbleMetric) => set({ bubbleMetric }),
  subgroup: null,
  setSubgroup: (subgroup) => set({ subgroup }),
  region: null,
  setRegion: (region) => set({ region }),
  year: null,
  setYear: (year2) => set({ year: year2 }),
  autoSwitchRegion: true,
  setAutoSwitchRegion: (autoSwitchRegion) => set({ autoSwitchRegion }),
  setDefaultsFromConfig: (config) => {
    var _a, _b, _c, _d, _e;
    const updates = {};
    const appConfig = config.app;
    updates["year"] = appConfig.default_year || ((_a = appConfig.years) == null ? void 0 : _a[0]);
    updates["region"] = appConfig.default_region || ((_c = (_b = config.regions) == null ? void 0 : _b[0]) == null ? void 0 : _c.id);
    updates["subgroup"] = appConfig.default_subgroup || ((_e = (_d = config.subgroups) == null ? void 0 : _d[0]) == null ? void 0 : _e.id);
    updates["choroplethMetric"] = appConfig.default_choropleth_metric;
    updates["bubbleMetric"] = appConfig.default_bubble_metric;
    set(updates);
  },
  set
}));
function getRegionFromGeoid(geoid) {
  switch (geoid.length) {
    case 2:
      return "states";
    case 5:
      return "counties";
    case 11:
      return "tracts";
    case 7:
      return "cities";
    case 12:
      return "bg";
    default:
      throw new Error("Could not determine region type from geoid");
  }
}
function getLocationContextFromGeoid(geoid) {
  if (typeof geoid !== "string" || geoid.length < 2)
    return {};
  return {
    state: getStateFromGeoid(geoid),
    county: getCountyFromGeoid(geoid),
    city: getCityFromGeoid(geoid),
    tract: getTractFromGeoid(geoid),
    bg: getBlockGroupFromGeoid(geoid)
  };
}
function getStateFromGeoid(geoid) {
  if (typeof geoid !== "string" || geoid.length < 2)
    return null;
  return geoid.substring(0, 2);
}
function getCountyFromGeoid(geoid) {
  if (typeof geoid !== "string" || geoid.length < 5)
    return null;
  return geoid.substring(0, 5);
}
function getTractFromGeoid(geoid) {
  if (typeof geoid !== "string" || geoid.length < 11)
    return null;
  return geoid.substring(0, 11);
}
function getCityFromGeoid(geoid) {
  if (typeof geoid !== "string" || geoid.length < 8)
    return null;
  return geoid.substring(0, 7);
}
function getBlockGroupFromGeoid(geoid) {
  if (typeof geoid !== "string" || geoid.length < 12)
    return null;
  return geoid.substring(0, 12);
}
function areEqual(a, b) {
  return a.properties.GEOID === b.properties.GEOID;
}
function getNextColor(usedColors, availableColors) {
  const nextUnusedColor = availableColors.find((c) => !usedColors.includes(c));
  if (nextUnusedColor)
    return nextUnusedColor;
  const lastColor = usedColors[usedColors.length - 1];
  const colorIndex = availableColors.indexOf(lastColor);
  const nextColorIndex = (colorIndex + 1) % availableColors.length;
  return availableColors[nextColorIndex];
}
function useToggleLocation() {
  const locationColors = useAppConfig("location_colors");
  const selected = useLocationStore((state) => state.selected);
  const addSelected = useLocationStore((state) => state.addSelected);
  const removeSelected = useLocationStore((state) => state.removeSelected);
  return useCallback((feature) => {
    if (!(feature == null ? void 0 : feature.properties))
      return;
    const alreadyExists = selected.some((f2) => areEqual(f2, feature));
    if (alreadyExists)
      return removeSelected(feature);
    const selectedColors = selected.map((f2) => f2.properties.color);
    const color2 = getNextColor(selectedColors, locationColors);
    addSelected(__spreadProps(__spreadValues({}, feature), { properties: __spreadProps(__spreadValues({}, feature.properties), { color: color2 }) }));
  }, [selected, locationColors, addSelected, removeSelected]);
}
function useToggleSelectedLocation() {
  console.warn(`useToggleSelectedLocation is deprecated.  Use useToggleLocation instead.`);
  return useToggleLocation();
}
const useLocationStore = create((set, get) => ({
  selected: [],
  addSelected: (selected) => set((state) => {
    const alreadyExists = state.selected.some((f2) => areEqual(f2, selected));
    if (alreadyExists)
      return {};
    return { selected: [...state.selected, selected] };
  }),
  removeSelected: (selectedId) => set((state) => {
    var _a;
    if (typeof selectedId === "object")
      selectedId = (selectedId == null ? void 0 : selectedId.GEOID) || ((_a = selectedId == null ? void 0 : selectedId.properties) == null ? void 0 : _a.GEOID);
    if (typeof selectedId !== "string") {
      console.warn("expected a GEOID string when removing a location");
      return;
    }
    return {
      selected: state.selected.filter((f2) => {
        var _a2;
        return ((_a2 = f2 == null ? void 0 : f2.properties) == null ? void 0 : _a2.GEOID) !== selectedId;
      })
    };
  }),
  isSelected: (feature) => get().selected.some((f2) => areEqual(f2, feature)),
  set
}));
function useLocationState(key) {
  return useLocationStore((state) => state[key]);
}
function useAddLocation() {
  return useLocationState("addSelected");
}
function useRemoveLocation() {
  return useLocationState("removeSelected");
}
function useLocationFeature(prop) {
  const features = useLocationState("selected");
  if (!prop)
    return features;
  if (typeof prop === "number")
    return features.slice(-1 * prop);
  if (typeof prop === "string")
    return features.find((f2) => areEqual(f2, { properties: { GEOID: prop } }));
  console.warn("useLocationFeature: unexpected argument, returning all features");
  return features;
}
function useLocationData(prop) {
  const features = useLocationFeature(prop);
  if (Array.isArray(features))
    return features.map((f2) => f2 == null ? void 0 : f2.properties);
  if (typeof features === "object")
    return features == null ? void 0 : features.properties;
  console.warn("useLocationData: unexpected value for location feature");
  return features;
}
const useDebouncedEffect = (func, deps, time) => {
  useEffect(() => {
    let db = setTimeout(() => {
      func();
    }, time);
    return () => {
      clearTimeout(db);
    };
  }, deps);
};
const QueryParamRouter = ({ varMap: varMapOverride, updateParams }) => {
  const [varMap, setVarMap] = useRouteStore((state) => [state.varMap, state.setVarMap], shallow);
  const dashboardState = useDashboardStore(({ choroplethMetric, bubbleMetric, subgroup, region, year: year2 }) => ({
    choroplethMetric,
    bubbleMetric,
    subgroup,
    region,
    year: year2
  }), shallow);
  const language = useLangStore((state) => state.language);
  const langDict = useLangStore((state) => state.dict);
  const hasMultipleLanguages = Object.keys(langDict).length > 1;
  const viewState = useMapStore((state) => state.viewState);
  const selected = useLocationStore((state) => state.selected);
  const setQueryParams = useRouteStore((state) => state.setQueryParams);
  useEffect(() => {
    varMapOverride && typeof varMapOverride === "object" && setVarMap(varMapOverride);
  }, [varMapOverride, setVarMap]);
  useDebouncedEffect(() => {
    const { zoom, latitude, longitude } = viewState;
    const state = __spreadProps(__spreadValues({}, dashboardState), {
      zoom: zoom == null ? void 0 : zoom.toFixed(2),
      latitude: latitude == null ? void 0 : latitude.toFixed(2),
      longitude: longitude == null ? void 0 : longitude.toFixed(2),
      locations: selected
    });
    if (hasMultipleLanguages)
      state.lang = language;
    const mappedParams = mapStateToQueryParams({ state, varMap });
    const newParams = typeof updateParams === "function" ? updateParams({ state, varMap, params: mappedParams }) : mappedParams;
    setQueryParams(newParams);
    setUrlQueryParams(newParams);
  }, [
    dashboardState,
    language,
    hasMultipleLanguages,
    viewState,
    setQueryParams,
    varMap,
    selected,
    updateParams
  ], 1e3);
  return null;
};
QueryParamRouter.propTypes = {
  varMap: PropTypes.object,
  updateParams: PropTypes.func
};
function getDefaultsFromConfig(config) {
  var _a, _b, _c, _d, _e;
  const values = {};
  const appConfig = config.app;
  values["year"] = appConfig.default_year || ((_a = appConfig.years) == null ? void 0 : _a[0]);
  values["region"] = appConfig.default_region || ((_c = (_b = config.regions) == null ? void 0 : _b[0]) == null ? void 0 : _c.id);
  values["subgroup"] = appConfig.default_subgroup || ((_e = (_d = config.subgroups) == null ? void 0 : _d[0]) == null ? void 0 : _e.id);
  values["choroplethMetric"] = appConfig.default_choropleth_metric;
  values["bubbleMetric"] = appConfig.default_bubble_metric;
  return values;
}
function interpolateKey(key, context) {
  var _a, _b;
  if (!key)
    return null;
  const newContext = __spreadValues({}, context);
  if (((_a = context.year) == null ? void 0 : _a.length) === 4)
    newContext["yy"] = context.year.toString().slice(-2);
  if (((_b = context.year) == null ? void 0 : _b.length) === 4)
    newContext["decade"] = context.year[2] + "0";
  return interpolateString(key, newContext);
}
const dummyOnLoad = () => {
  return Promise.resolve();
};
function useConfigLoader({ config, onLoad = dummyOnLoad }) {
  const loadConfig2 = useLoadConfig();
  const routeValues = useCurrentRouteParams();
  const setReady = useConfigStore((state) => state.setReady);
  const isLoading = useRef(false);
  useEffect(() => {
    if (isLoading.current)
      return;
    isLoading.current = true;
    loadConfig2(config).then((loadedConfig) => {
      const defaultValues = getDefaultsFromConfig(loadedConfig);
      const loadedValues = __spreadValues(__spreadValues({}, defaultValues), routeValues);
      onLoad({ config: loadedConfig, defaultValues: loadedValues }).then(() => {
        setReady(true);
        isLoading.current = false;
      }).catch((err) => {
        console.error(err);
        throw new Error("Error running onLoad callback");
      });
    });
  }, [config, onLoad]);
}
function useOnConfigLoad() {
  const setValues = useDashboardStore((state) => state.set);
  const setViewState = useMapStore((state) => state.setViewState);
  const setLanguage = useLangStore((state) => state.setLanguage);
  return useCallback(({ config, defaultValues }) => {
    const _a = defaultValues, { zoom, latitude, longitude, locations, lang } = _a, dashboardState = __objRest(_a, ["zoom", "latitude", "longitude", "locations", "lang"]);
    const dashboardValues = [
      "choroplethMetric",
      "bubbleMetric",
      "year",
      "region",
      "subgroup"
    ].reduce((acc, key) => {
      if (dashboardState[key])
        acc[key] = dashboardState[key];
      return acc;
    }, {});
    setValues(dashboardValues);
    zoom && latitude && longitude && setViewState({
      zoom: Number(zoom),
      latitude: Number(latitude),
      longitude: Number(longitude)
    });
    lang && setLanguage(lang);
    return Promise.resolve({ config, defaultValues });
  }, [setValues, setViewState]);
}
function useAppConfig(key) {
  const appConfig = useConfigStore((state) => state.app);
  return useMemo(() => key ? appConfig[key] : appConfig, [key, appConfig]);
}
function useScaleConfig(context) {
  const scales = useConfig("scales");
  const defaultScale = scales.find((s) => s.id === "default") || {};
  const bestMatch = getBestMatch(context, scales);
  return __spreadValues(__spreadValues({}, defaultScale), bestMatch);
}
function useDataSourceConfig(context) {
  const dataSources = useConfig("dataSources");
  return getBestMatch(context, dataSources);
}
function useMapLayersConfig(context) {
  const mapLayers = useConfig("mapLayers");
  return getAllMatches(context, mapLayers).map((layerConfig) => {
    const overrides = {};
    if (layerConfig.source_id) {
      overrides.source_id = interpolateKey(layerConfig.source_id, context);
    }
    return __spreadValues(__spreadValues({}, layerConfig), overrides);
  });
}
function formatDecimal$1(x) {
  return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function formatDecimalParts(x, p2) {
  if ((i = (x = p2 ? x.toExponential(p2 - 1) : x.toExponential()).indexOf("e")) < 0)
    return null;
  var i, coefficient = x.slice(0, i);
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
}
function exponent(x) {
  return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
}
function formatGroup(grouping, thousands) {
  return function(value, width) {
    var i = value.length, t = [], j = 0, g2 = grouping[0], length = 0;
    while (i > 0 && g2 > 0) {
      if (length + g2 + 1 > width)
        g2 = Math.max(1, width - length);
      t.push(value.substring(i -= g2, i + g2));
      if ((length += g2 + 1) > width)
        break;
      g2 = grouping[j = (j + 1) % grouping.length];
    }
    return t.reverse().join(thousands);
  };
}
function formatNumerals(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
}
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
  if (!(match = re.exec(specifier)))
    throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}
formatSpecifier.prototype = FormatSpecifier.prototype;
function FormatSpecifier(specifier) {
  this.fill = specifier.fill === void 0 ? " " : specifier.fill + "";
  this.align = specifier.align === void 0 ? ">" : specifier.align + "";
  this.sign = specifier.sign === void 0 ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === void 0 ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === void 0 ? void 0 : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === void 0 ? void 0 : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === void 0 ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function formatTrim(s) {
  out:
    for (var n2 = s.length, i = 1, i0 = -1, i1; i < n2; ++i) {
      switch (s[i]) {
        case ".":
          i0 = i1 = i;
          break;
        case "0":
          if (i0 === 0)
            i0 = i;
          i1 = i;
          break;
        default:
          if (!+s[i])
            break out;
          if (i0 > 0)
            i0 = 0;
          break;
      }
    }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}
var prefixExponent;
function formatPrefixAuto(x, p2) {
  var d = formatDecimalParts(x, p2);
  if (!d)
    return x + "";
  var coefficient = d[0], exponent2 = d[1], i = exponent2 - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent2 / 3))) * 3) + 1, n2 = coefficient.length;
  return i === n2 ? coefficient : i > n2 ? coefficient + new Array(i - n2 + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p2 + i - 1))[0];
}
function formatRounded(x, p2) {
  var d = formatDecimalParts(x, p2);
  if (!d)
    return x + "";
  var coefficient = d[0], exponent2 = d[1];
  return exponent2 < 0 ? "0." + new Array(-exponent2).join("0") + coefficient : coefficient.length > exponent2 + 1 ? coefficient.slice(0, exponent2 + 1) + "." + coefficient.slice(exponent2 + 1) : coefficient + new Array(exponent2 - coefficient.length + 2).join("0");
}
var formatTypes = {
  "%": (x, p2) => (x * 100).toFixed(p2),
  "b": (x) => Math.round(x).toString(2),
  "c": (x) => x + "",
  "d": formatDecimal$1,
  "e": (x, p2) => x.toExponential(p2),
  "f": (x, p2) => x.toFixed(p2),
  "g": (x, p2) => x.toPrecision(p2),
  "o": (x) => Math.round(x).toString(8),
  "p": (x, p2) => formatRounded(x * 100, p2),
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": (x) => Math.round(x).toString(16).toUpperCase(),
  "x": (x) => Math.round(x).toString(16)
};
function identity(x) {
  return x;
}
var map = Array.prototype.map, prefixes = ["y", "z", "a", "f", "p", "n", "\xB5", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function formatLocale$1(locale2) {
  var group = locale2.grouping === void 0 || locale2.thousands === void 0 ? identity : formatGroup(map.call(locale2.grouping, Number), locale2.thousands + ""), currencyPrefix = locale2.currency === void 0 ? "" : locale2.currency[0] + "", currencySuffix = locale2.currency === void 0 ? "" : locale2.currency[1] + "", decimal = locale2.decimal === void 0 ? "." : locale2.decimal + "", numerals = locale2.numerals === void 0 ? identity : formatNumerals(map.call(locale2.numerals, String)), percent = locale2.percent === void 0 ? "%" : locale2.percent + "", minus = locale2.minus === void 0 ? "\u2212" : locale2.minus + "", nan = locale2.nan === void 0 ? "NaN" : locale2.nan + "";
  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);
    var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
    if (type === "n")
      comma = true, type = "g";
    else if (!formatTypes[type])
      precision === void 0 && (precision = 12), trim = true, type = "g";
    if (zero || fill === "0" && align === "=")
      zero = true, fill = "0", align = "=";
    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
    var formatType = formatTypes[type], maybeSuffix = /[defgprs%]/.test(type);
    precision = precision === void 0 ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
    function format2(value) {
      var valuePrefix = prefix, valueSuffix = suffix, i, n2, c;
      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;
        var valueNegative = value < 0 || 1 / value < 0;
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
        if (trim)
          value = formatTrim(value);
        if (valueNegative && +value === 0 && sign !== "+")
          valueNegative = false;
        valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
        if (maybeSuffix) {
          i = -1, n2 = value.length;
          while (++i < n2) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }
      if (comma && !zero)
        value = group(value, Infinity);
      var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
      if (comma && zero)
        value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
      switch (align) {
        case "<":
          value = valuePrefix + value + valueSuffix + padding;
          break;
        case "=":
          value = valuePrefix + padding + value + valueSuffix;
          break;
        case "^":
          value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
          break;
        default:
          value = padding + valuePrefix + value + valueSuffix;
          break;
      }
      return numerals(value);
    }
    format2.toString = function() {
      return specifier + "";
    };
    return format2;
  }
  function formatPrefix(specifier, value) {
    var f2 = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3, k = Math.pow(10, -e), prefix = prefixes[8 + e / 3];
    return function(value2) {
      return f2(k * value2) + prefix;
    };
  }
  return {
    format: newFormat,
    formatPrefix
  };
}
var locale$1;
var format;
defaultLocale$1({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function defaultLocale$1(definition) {
  locale$1 = formatLocale$1(definition);
  format = locale$1.format;
  return locale$1;
}
var t0 = new Date(), t1 = new Date();
function newInterval(floori, offseti, count, field) {
  function interval(date) {
    return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
  }
  interval.floor = function(date) {
    return floori(date = new Date(+date)), date;
  };
  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };
  interval.round = function(date) {
    var d0 = interval(date), d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };
  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };
  interval.range = function(start, stop, step) {
    var range = [], previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0))
      return range;
    do
      range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };
  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date)
        while (floori(date), !test(date))
          date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0)
          while (++step <= 0) {
            while (offseti(date, -1), !test(date)) {
            }
          }
        else
          while (--step >= 0) {
            while (offseti(date, 1), !test(date)) {
            }
          }
      }
    });
  };
  if (count) {
    interval.count = function(start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };
    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
        return field(d) % step === 0;
      } : function(d) {
        return interval.count(0, d) % step === 0;
      });
    };
  }
  return interval;
}
const durationSecond = 1e3;
const durationMinute = durationSecond * 60;
const durationHour = durationMinute * 60;
const durationDay = durationHour * 24;
const durationWeek = durationDay * 7;
var day = newInterval((date) => date.setHours(0, 0, 0, 0), (date, step) => date.setDate(date.getDate() + step), (start, end) => (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay, (date) => date.getDate() - 1);
var timeDay = day;
function weekday(i) {
  return newInterval(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
  });
}
var sunday = weekday(0);
var monday = weekday(1);
weekday(2);
weekday(3);
var thursday = weekday(4);
weekday(5);
weekday(6);
var year = newInterval(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};
var timeYear = year;
var utcDay = newInterval(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / durationDay;
}, function(date) {
  return date.getUTCDate() - 1;
});
var utcDay$1 = utcDay;
function utcWeekday(i) {
  return newInterval(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / durationWeek;
  });
}
var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
utcWeekday(2);
utcWeekday(3);
var utcThursday = utcWeekday(4);
utcWeekday(5);
utcWeekday(6);
var utcYear = newInterval(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};
var utcYear$1 = utcYear;
function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function newDate(y, m2, d) {
  return { y, m: m2, d, H: 0, M: 0, S: 0, L: 0 };
}
function formatLocale(locale2) {
  var locale_dateTime = locale2.dateTime, locale_date = locale2.date, locale_time = locale2.time, locale_periods = locale2.periods, locale_weekdays = locale2.days, locale_shortWeekdays = locale2.shortDays, locale_months = locale2.months, locale_shortMonths = locale2.shortMonths;
  var periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths);
  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth2,
    "B": formatMonth2,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "g": formatYearISO,
    "G": formatFullYearISO,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "q": formatQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear$1,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };
  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "g": formatUTCYearISO,
    "G": formatUTCFullYearISO,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "q": formatUTCQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };
  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "g": parseYear,
    "G": parseFullYear,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "q": parseQuarter,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);
  function newFormat(specifier, formats2) {
    return function(date) {
      var string = [], i = -1, j = 0, n2 = specifier.length, c, pad2, format2;
      if (!(date instanceof Date))
        date = new Date(+date);
      while (++i < n2) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad2 = pads[c = specifier.charAt(++i)]) != null)
            c = specifier.charAt(++i);
          else
            pad2 = c === "e" ? " " : "0";
          if (format2 = formats2[c])
            c = format2(date, pad2);
          string.push(c);
          j = i + 1;
        }
      }
      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }
  function newParse(specifier, Z) {
    return function(string) {
      var d = newDate(1900, void 0, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day2;
      if (i != string.length)
        return null;
      if ("Q" in d)
        return new Date(d.Q);
      if ("s" in d)
        return new Date(d.s * 1e3 + ("L" in d ? d.L : 0));
      if (Z && !("Z" in d))
        d.Z = 0;
      if ("p" in d)
        d.H = d.H % 12 + d.p * 12;
      if (d.m === void 0)
        d.m = "q" in d ? d.q : 0;
      if ("V" in d) {
        if (d.V < 1 || d.V > 53)
          return null;
        if (!("w" in d))
          d.w = 1;
        if ("Z" in d) {
          week = utcDate(newDate(d.y, 0, 1)), day2 = week.getUTCDay();
          week = day2 > 4 || day2 === 0 ? utcMonday.ceil(week) : utcMonday(week);
          week = utcDay$1.offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = localDate(newDate(d.y, 0, 1)), day2 = week.getDay();
          week = day2 > 4 || day2 === 0 ? monday.ceil(week) : monday(week);
          week = timeDay.offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d))
          d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day2 = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day2 + 5) % 7 : d.w + d.U * 7 - (day2 + 6) % 7;
      }
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }
      return localDate(d);
    };
  }
  function parseSpecifier(d, specifier, string, j) {
    var i = 0, n2 = specifier.length, m2 = string.length, c, parse3;
    while (i < n2) {
      if (j >= m2)
        return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse3 = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse3 || (j = parse3(d, string, j)) < 0)
          return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }
    return j;
  }
  function parsePeriod(d, string, i) {
    var n2 = periodRe.exec(string.slice(i));
    return n2 ? (d.p = periodLookup.get(n2[0].toLowerCase()), i + n2[0].length) : -1;
  }
  function parseShortWeekday(d, string, i) {
    var n2 = shortWeekdayRe.exec(string.slice(i));
    return n2 ? (d.w = shortWeekdayLookup.get(n2[0].toLowerCase()), i + n2[0].length) : -1;
  }
  function parseWeekday(d, string, i) {
    var n2 = weekdayRe.exec(string.slice(i));
    return n2 ? (d.w = weekdayLookup.get(n2[0].toLowerCase()), i + n2[0].length) : -1;
  }
  function parseShortMonth(d, string, i) {
    var n2 = shortMonthRe.exec(string.slice(i));
    return n2 ? (d.m = shortMonthLookup.get(n2[0].toLowerCase()), i + n2[0].length) : -1;
  }
  function parseMonth(d, string, i) {
    var n2 = monthRe.exec(string.slice(i));
    return n2 ? (d.m = monthLookup.get(n2[0].toLowerCase()), i + n2[0].length) : -1;
  }
  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }
  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }
  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }
  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }
  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }
  function formatShortMonth2(d) {
    return locale_shortMonths[d.getMonth()];
  }
  function formatMonth2(d) {
    return locale_months[d.getMonth()];
  }
  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }
  function formatQuarter(d) {
    return 1 + ~~(d.getMonth() / 3);
  }
  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }
  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }
  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }
  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }
  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }
  function formatUTCQuarter(d) {
    return 1 + ~~(d.getUTCMonth() / 3);
  }
  return {
    format: function(specifier) {
      var f2 = newFormat(specifier += "", formats);
      f2.toString = function() {
        return specifier;
      };
      return f2;
    },
    parse: function(specifier) {
      var p2 = newParse(specifier += "", false);
      p2.toString = function() {
        return specifier;
      };
      return p2;
    },
    utcFormat: function(specifier) {
      var f2 = newFormat(specifier += "", utcFormats);
      f2.toString = function() {
        return specifier;
      };
      return f2;
    },
    utcParse: function(specifier) {
      var p2 = newParse(specifier += "", true);
      p2.toString = function() {
        return specifier;
      };
      return p2;
    }
  };
}
var pads = { "-": "", "_": " ", "0": "0" }, numberRe = /^\s*\d+/, percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
function pad$1(value, fill, width) {
  var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function requote(s) {
  return s.replace(requoteRe, "\\$&");
}
function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}
function formatLookup(names) {
  return new Map(names.map((name, i) => [name.toLowerCase(), i]));
}
function parseWeekdayNumberSunday(d, string, i) {
  var n2 = numberRe.exec(string.slice(i, i + 1));
  return n2 ? (d.w = +n2[0], i + n2[0].length) : -1;
}
function parseWeekdayNumberMonday(d, string, i) {
  var n2 = numberRe.exec(string.slice(i, i + 1));
  return n2 ? (d.u = +n2[0], i + n2[0].length) : -1;
}
function parseWeekNumberSunday(d, string, i) {
  var n2 = numberRe.exec(string.slice(i, i + 2));
  return n2 ? (d.U = +n2[0], i + n2[0].length) : -1;
}
function parseWeekNumberISO(d, string, i) {
  var n2 = numberRe.exec(string.slice(i, i + 2));
  return n2 ? (d.V = +n2[0], i + n2[0].length) : -1;
}
function parseWeekNumberMonday(d, string, i) {
  var n2 = numberRe.exec(string.slice(i, i + 2));
  return n2 ? (d.W = +n2[0], i + n2[0].length) : -1;
}
function parseFullYear(d, string, i) {
  var n2 = numberRe.exec(string.slice(i, i + 4));
  return n2 ? (d.y = +n2[0], i + n2[0].length) : -1;
}
function parseYear(d, string, i) {
  var n2 = numberRe.exec(string.slice(i, i + 2));
  return n2 ? (d.y = +n2[0] + (+n2[0] > 68 ? 1900 : 2e3), i + n2[0].length) : -1;
}
function parseZone(d, string, i) {
  var n2 = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n2 ? (d.Z = n2[1] ? 0 : -(n2[2] + (n2[3] || "00")), i + n2[0].length) : -1;
}
function parseQuarter(d, string, i) {
  var n2 = numberRe.exec(string.slice(i, i + 1));
  return n2 ? (d.q = n2[0] * 3 - 3, i + n2[0].length) : -1;
}
function parseMonthNumber(d, string, i) {
  var n2 = numberRe.exec(string.slice(i, i + 2));
  return n2 ? (d.m = n2[0] - 1, i + n2[0].length) : -1;
}
function parseDayOfMonth(d, string, i) {
  var n2 = numberRe.exec(string.slice(i, i + 2));
  return n2 ? (d.d = +n2[0], i + n2[0].length) : -1;
}
function parseDayOfYear(d, string, i) {
  var n2 = numberRe.exec(string.slice(i, i + 3));
  return n2 ? (d.m = 0, d.d = +n2[0], i + n2[0].length) : -1;
}
function parseHour24(d, string, i) {
  var n2 = numberRe.exec(string.slice(i, i + 2));
  return n2 ? (d.H = +n2[0], i + n2[0].length) : -1;
}
function parseMinutes(d, string, i) {
  var n2 = numberRe.exec(string.slice(i, i + 2));
  return n2 ? (d.M = +n2[0], i + n2[0].length) : -1;
}
function parseSeconds(d, string, i) {
  var n2 = numberRe.exec(string.slice(i, i + 2));
  return n2 ? (d.S = +n2[0], i + n2[0].length) : -1;
}
function parseMilliseconds(d, string, i) {
  var n2 = numberRe.exec(string.slice(i, i + 3));
  return n2 ? (d.L = +n2[0], i + n2[0].length) : -1;
}
function parseMicroseconds(d, string, i) {
  var n2 = numberRe.exec(string.slice(i, i + 6));
  return n2 ? (d.L = Math.floor(n2[0] / 1e3), i + n2[0].length) : -1;
}
function parseLiteralPercent(d, string, i) {
  var n2 = percentRe.exec(string.slice(i, i + 1));
  return n2 ? i + n2[0].length : -1;
}
function parseUnixTimestamp(d, string, i) {
  var n2 = numberRe.exec(string.slice(i));
  return n2 ? (d.Q = +n2[0], i + n2[0].length) : -1;
}
function parseUnixTimestampSeconds(d, string, i) {
  var n2 = numberRe.exec(string.slice(i));
  return n2 ? (d.s = +n2[0], i + n2[0].length) : -1;
}
function formatDayOfMonth(d, p2) {
  return pad$1(d.getDate(), p2, 2);
}
function formatHour24(d, p2) {
  return pad$1(d.getHours(), p2, 2);
}
function formatHour12(d, p2) {
  return pad$1(d.getHours() % 12 || 12, p2, 2);
}
function formatDayOfYear(d, p2) {
  return pad$1(1 + timeDay.count(timeYear(d), d), p2, 3);
}
function formatMilliseconds(d, p2) {
  return pad$1(d.getMilliseconds(), p2, 3);
}
function formatMicroseconds(d, p2) {
  return formatMilliseconds(d, p2) + "000";
}
function formatMonthNumber(d, p2) {
  return pad$1(d.getMonth() + 1, p2, 2);
}
function formatMinutes(d, p2) {
  return pad$1(d.getMinutes(), p2, 2);
}
function formatSeconds(d, p2) {
  return pad$1(d.getSeconds(), p2, 2);
}
function formatWeekdayNumberMonday(d) {
  var day2 = d.getDay();
  return day2 === 0 ? 7 : day2;
}
function formatWeekNumberSunday(d, p2) {
  return pad$1(sunday.count(timeYear(d) - 1, d), p2, 2);
}
function dISO(d) {
  var day2 = d.getDay();
  return day2 >= 4 || day2 === 0 ? thursday(d) : thursday.ceil(d);
}
function formatWeekNumberISO(d, p2) {
  d = dISO(d);
  return pad$1(thursday.count(timeYear(d), d) + (timeYear(d).getDay() === 4), p2, 2);
}
function formatWeekdayNumberSunday(d) {
  return d.getDay();
}
function formatWeekNumberMonday(d, p2) {
  return pad$1(monday.count(timeYear(d) - 1, d), p2, 2);
}
function formatYear$1(d, p2) {
  return pad$1(d.getFullYear() % 100, p2, 2);
}
function formatYearISO(d, p2) {
  d = dISO(d);
  return pad$1(d.getFullYear() % 100, p2, 2);
}
function formatFullYear(d, p2) {
  return pad$1(d.getFullYear() % 1e4, p2, 4);
}
function formatFullYearISO(d, p2) {
  var day2 = d.getDay();
  d = day2 >= 4 || day2 === 0 ? thursday(d) : thursday.ceil(d);
  return pad$1(d.getFullYear() % 1e4, p2, 4);
}
function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+")) + pad$1(z / 60 | 0, "0", 2) + pad$1(z % 60, "0", 2);
}
function formatUTCDayOfMonth(d, p2) {
  return pad$1(d.getUTCDate(), p2, 2);
}
function formatUTCHour24(d, p2) {
  return pad$1(d.getUTCHours(), p2, 2);
}
function formatUTCHour12(d, p2) {
  return pad$1(d.getUTCHours() % 12 || 12, p2, 2);
}
function formatUTCDayOfYear(d, p2) {
  return pad$1(1 + utcDay$1.count(utcYear$1(d), d), p2, 3);
}
function formatUTCMilliseconds(d, p2) {
  return pad$1(d.getUTCMilliseconds(), p2, 3);
}
function formatUTCMicroseconds(d, p2) {
  return formatUTCMilliseconds(d, p2) + "000";
}
function formatUTCMonthNumber(d, p2) {
  return pad$1(d.getUTCMonth() + 1, p2, 2);
}
function formatUTCMinutes(d, p2) {
  return pad$1(d.getUTCMinutes(), p2, 2);
}
function formatUTCSeconds(d, p2) {
  return pad$1(d.getUTCSeconds(), p2, 2);
}
function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}
function formatUTCWeekNumberSunday(d, p2) {
  return pad$1(utcSunday.count(utcYear$1(d) - 1, d), p2, 2);
}
function UTCdISO(d) {
  var day2 = d.getUTCDay();
  return day2 >= 4 || day2 === 0 ? utcThursday(d) : utcThursday.ceil(d);
}
function formatUTCWeekNumberISO(d, p2) {
  d = UTCdISO(d);
  return pad$1(utcThursday.count(utcYear$1(d), d) + (utcYear$1(d).getUTCDay() === 4), p2, 2);
}
function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}
function formatUTCWeekNumberMonday(d, p2) {
  return pad$1(utcMonday.count(utcYear$1(d) - 1, d), p2, 2);
}
function formatUTCYear(d, p2) {
  return pad$1(d.getUTCFullYear() % 100, p2, 2);
}
function formatUTCYearISO(d, p2) {
  d = UTCdISO(d);
  return pad$1(d.getUTCFullYear() % 100, p2, 2);
}
function formatUTCFullYear(d, p2) {
  return pad$1(d.getUTCFullYear() % 1e4, p2, 4);
}
function formatUTCFullYearISO(d, p2) {
  var day2 = d.getUTCDay();
  d = day2 >= 4 || day2 === 0 ? utcThursday(d) : utcThursday.ceil(d);
  return pad$1(d.getUTCFullYear() % 1e4, p2, 4);
}
function formatUTCZone() {
  return "+0000";
}
function formatLiteralPercent() {
  return "%";
}
function formatUnixTimestamp(d) {
  return +d;
}
function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1e3);
}
var locale;
var timeFormat;
defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function defaultLocale(definition) {
  locale = formatLocale(definition);
  timeFormat = locale.format;
  return locale;
}
const PRECISION_FORMATS = {
  1e-3: format(".4~f"),
  0.01: format(".3~f"),
  0.1: format(".3~f"),
  1: format(".2~f"),
  100: format(".1~f"),
  1e3: format(",d"),
  1e4: format(".2~s"),
  1e5: format(".3~s"),
  1e6: format(".3~s"),
  1e7: format(".3~s")
};
function autoFormatNumber(num) {
  num = Number(num);
  const precisionKeys = Object.keys(PRECISION_FORMATS);
  const intervals = precisionKeys.map((k) => Number(k));
  if (num > 1e7)
    return PRECISION_FORMATS[1e7](num);
  for (let i = 0; i < intervals.length; i++) {
    if (num < intervals[i]) {
      return PRECISION_FORMATS[precisionKeys[i]](num);
    }
  }
}
const formatInteger = format(",d");
const formatIntegerShort = format("~s");
const formatDecimal = (value, precision = 2) => format(`,.${precision}f`)(value);
const formatDate8601 = timeFormat("%Y-%m-%d");
const formatShortDate = timeFormat("%b %d, '%y");
const formatFullDate = timeFormat("%B %d, %Y");
const formatMonth = timeFormat("%B");
const formatShortMonth = timeFormat("%b");
const formatMonthDay = timeFormat("%b %d");
const formatMonthYear = timeFormat("%b '%y");
const formatPercent = format(".2~p");
const formatDollars = format("$,d");
const formatCurrency = (value) => `$${autoFormatNumber(value)}`;
const formatFullCurrency = format("$,.2~f");
const formatYesNo = (v) => v ? "Yes" : "No";
const formatOnOff = (v) => v ? "On" : "Off";
const formatNothing = (value) => value;
const formatPercentValue = (value) => autoFormatNumber(value) + "%";
function getFormatter(type) {
  switch (type) {
    case "number":
      return autoFormatNumber;
    case "integer":
      return formatInteger;
    case "interger_short":
      return formatIntegerShort;
    case "float":
      return formatDecimal;
    case "date":
      return formatDate8601;
    case "full_date":
      return formatFullDate;
    case "short_date":
      return formatShortDate;
    case "month":
      return formatMonth;
    case "short_month":
      return formatShortMonth;
    case "month_day":
      return formatMonthDay;
    case "month_year":
      return formatMonthYear;
    case "percent":
      return formatPercent;
    case "percent_value":
      return formatPercentValue;
    case "dollars":
      return formatDollars;
    case "currency":
      return formatCurrency;
    case "full_currency":
      return formatFullCurrency;
    case "yes_no":
      return formatYesNo;
    case "on_off":
      return formatOnOff;
    default:
      return formatNothing;
  }
}
function useMetricConfig(id) {
  const metrics = useConfigStore((state) => state.metrics);
  const idArray = typeof id === "string" ? [id] : Array.isArray(id) ? id : metrics.map((m2) => m2.id);
  const metricNames = useLangObject(idArray, { prefix: "METRIC_" });
  const metricHints = useLangObject(idArray, { prefix: "HINT_" });
  const metricUnits = useLangObject(idArray, { prefix: "UNIT_" });
  return useMemo(() => {
    const sourceMetrics = idArray.length !== metrics.length ? metrics.filter((m2) => idArray.indexOf(m2.id) > -1) : metrics;
    const metricFormatters = sourceMetrics.reduce((formattersById, m2) => {
      formattersById[m2.id] = {
        formatter: getFormatter(m2.format),
        shortFormatter: getFormatter(m2.short_format || m2.format)
      };
      return formattersById;
    }, {});
    const metricsWithLang = sourceMetrics.map((m2) => {
      return __spreadValues(__spreadProps(__spreadValues({}, m2), {
        name: metricNames[m2.id],
        hint: metricHints[m2.id],
        unit: metricUnits[m2.id]
      }), metricFormatters[m2.id]);
    });
    if (typeof id === "string")
      return metricsWithLang.find((m2) => m2.id === id);
    return metricsWithLang;
  }, [id, metrics, metricNames, metricHints, metricUnits]);
}
function useRegionConfig(id) {
  const regions = useConfigStore((state) => state.regions);
  const regionNames = useLangObject(regions.map((r) => r.id), { prefix: "REGION_" });
  return useMemo(() => {
    const regionsWithLang = regions.map((r) => {
      return __spreadProps(__spreadValues({}, r), {
        name: regionNames[r.id]
      });
    });
    if (!id)
      return regionsWithLang;
    return regionsWithLang.find((r) => r.id === id);
  }, [id, regions, regionNames]);
}
function useSubgroupConfig(id) {
  const subgroups = useConfigStore((state) => state.subgroups);
  const names = useLangObject(subgroups.map((r) => r.id), { prefix: "SUBGROUP_" });
  return useMemo(() => {
    const subgroupsWithLang = subgroups.map((r) => {
      return __spreadProps(__spreadValues({}, r), {
        name: names[r.id]
      });
    });
    if (!id)
      return subgroupsWithLang;
    return subgroupsWithLang.find((r) => r.id === id);
  }, [id, subgroups, names]);
}
function useAccessor() {
  const accessorKey = useAppConfig("accessor");
  return useCallback((context) => {
    if (!accessorKey)
      return context == null ? void 0 : context.metric_id;
    return interpolateKey(accessorKey, context);
  }, [accessorKey]);
}
function useMapSourceConfig(context) {
  const mapSources = useConfig("mapSources");
  return getAllMatches(context, mapSources);
}
var EOL = {}, EOF = {}, QUOTE = 34, NEWLINE = 10, RETURN = 13;
function objectConverter(columns) {
  return new Function("d", "return {" + columns.map(function(name, i) {
    return JSON.stringify(name) + ": d[" + i + '] || ""';
  }).join(",") + "}");
}
function customConverter(columns, f2) {
  var object = objectConverter(columns);
  return function(row, i) {
    return f2(object(row), i, columns);
  };
}
function inferColumns(rows) {
  var columnSet = /* @__PURE__ */ Object.create(null), columns = [];
  rows.forEach(function(row) {
    for (var column in row) {
      if (!(column in columnSet)) {
        columns.push(columnSet[column] = column);
      }
    }
  });
  return columns;
}
function pad(value, width) {
  var s = value + "", length = s.length;
  return length < width ? new Array(width - length + 1).join(0) + s : s;
}
function formatYear(year2) {
  return year2 < 0 ? "-" + pad(-year2, 6) : year2 > 9999 ? "+" + pad(year2, 6) : pad(year2, 4);
}
function formatDate(date) {
  var hours = date.getUTCHours(), minutes = date.getUTCMinutes(), seconds = date.getUTCSeconds(), milliseconds = date.getUTCMilliseconds();
  return isNaN(date) ? "Invalid Date" : formatYear(date.getUTCFullYear()) + "-" + pad(date.getUTCMonth() + 1, 2) + "-" + pad(date.getUTCDate(), 2) + (milliseconds ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2) + "." + pad(milliseconds, 3) + "Z" : seconds ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2) + "Z" : minutes || hours ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + "Z" : "");
}
function dsv(delimiter) {
  var reFormat = new RegExp('["' + delimiter + "\n\r]"), DELIMITER = delimiter.charCodeAt(0);
  function parse3(text, f2) {
    var convert2, columns, rows = parseRows(text, function(row, i) {
      if (convert2)
        return convert2(row, i - 1);
      columns = row, convert2 = f2 ? customConverter(row, f2) : objectConverter(row);
    });
    rows.columns = columns || [];
    return rows;
  }
  function parseRows(text, f2) {
    var rows = [], N = text.length, I = 0, n2 = 0, t, eof = N <= 0, eol = false;
    if (text.charCodeAt(N - 1) === NEWLINE)
      --N;
    if (text.charCodeAt(N - 1) === RETURN)
      --N;
    function token() {
      if (eof)
        return EOF;
      if (eol)
        return eol = false, EOL;
      var i, j = I, c;
      if (text.charCodeAt(j) === QUOTE) {
        while (I++ < N && text.charCodeAt(I) !== QUOTE || text.charCodeAt(++I) === QUOTE)
          ;
        if ((i = I) >= N)
          eof = true;
        else if ((c = text.charCodeAt(I++)) === NEWLINE)
          eol = true;
        else if (c === RETURN) {
          eol = true;
          if (text.charCodeAt(I) === NEWLINE)
            ++I;
        }
        return text.slice(j + 1, i - 1).replace(/""/g, '"');
      }
      while (I < N) {
        if ((c = text.charCodeAt(i = I++)) === NEWLINE)
          eol = true;
        else if (c === RETURN) {
          eol = true;
          if (text.charCodeAt(I) === NEWLINE)
            ++I;
        } else if (c !== DELIMITER)
          continue;
        return text.slice(j, i);
      }
      return eof = true, text.slice(j, N);
    }
    while ((t = token()) !== EOF) {
      var row = [];
      while (t !== EOL && t !== EOF)
        row.push(t), t = token();
      if (f2 && (row = f2(row, n2++)) == null)
        continue;
      rows.push(row);
    }
    return rows;
  }
  function preformatBody(rows, columns) {
    return rows.map(function(row) {
      return columns.map(function(column) {
        return formatValue(row[column]);
      }).join(delimiter);
    });
  }
  function format2(rows, columns) {
    if (columns == null)
      columns = inferColumns(rows);
    return [columns.map(formatValue).join(delimiter)].concat(preformatBody(rows, columns)).join("\n");
  }
  function formatBody(rows, columns) {
    if (columns == null)
      columns = inferColumns(rows);
    return preformatBody(rows, columns).join("\n");
  }
  function formatRows(rows) {
    return rows.map(formatRow).join("\n");
  }
  function formatRow(row) {
    return row.map(formatValue).join(delimiter);
  }
  function formatValue(value) {
    return value == null ? "" : value instanceof Date ? formatDate(value) : reFormat.test(value += "") ? '"' + value.replace(/"/g, '""') + '"' : value;
  }
  return {
    parse: parse3,
    parseRows,
    format: format2,
    formatBody,
    formatRows,
    formatRow,
    formatValue
  };
}
var csv = dsv(",");
var csvParse = csv.parse;
function autoType(object) {
  for (var key in object) {
    var value = object[key].trim(), number, m2;
    if (!value)
      value = null;
    else if (value === "true")
      value = true;
    else if (value === "false")
      value = false;
    else if (value === "NaN")
      value = NaN;
    else if (!isNaN(number = +value))
      value = number;
    else if (m2 = value.match(/^([-+]\d{2})?\d{4}(-\d{2}(-\d{2})?)?(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|[-+]\d{2}:\d{2})?)?$/)) {
      if (fixtz && !!m2[4] && !m2[7])
        value = value.replace(/-/g, "/").replace(/T/, " ");
      value = new Date(value);
    } else
      continue;
    object[key] = value;
  }
  return object;
}
const fixtz = new Date("2019-01-01T00:00").getHours() || new Date("2019-07-01T00:00").getHours();
const PASS_THROUGH = (v) => v;
async function fetchDataSource(url, parser) {
  const isCsv = url.endsWith(".csv");
  return fetch(url).then((response) => {
    return isCsv ? response.text() : response.json();
  }).then((data) => {
    return isCsv ? parseCsvString(data, parser) : parseJsonData(data, parser);
  });
}
function parseId(id) {
  return id.split("_").filter((v) => v !== "*").join("_");
}
function parseValue(value, options = {}) {
  if (!value && value !== 0)
    return null;
  const type = options.type;
  switch (type) {
    case "string":
      return value;
    case "integer":
      return parseInt(value, 10);
    case "float":
      return parseFloat(value);
    case "boolean":
      return value.toLowerCase() === "true" || value === "1";
    case "date":
      if (value.match(/^\d{4}-\d{2}-\d{2}$/))
        return new Date(`${value}T00:00`);
      return new Date(value);
    default:
      return autoType([value])[0];
  }
}
function parseValues(stringValue, options = {}) {
  const type = options.type;
  const separator = options.separator || ";";
  if (!stringValue)
    return null;
  if (typeof stringValue !== "string")
    return stringValue;
  if (stringValue.indexOf(separator) === -1)
    return parseValue(stringValue, { type });
  return stringValue.split(separator).map((v) => parseValue(v, { type }));
}
function parseJsonData(data, parser = PASS_THROUGH) {
  return Array.isArray(data) ? data.map(parser) : parser(data);
}
function parseCsvString(data, parser = autoType) {
  return csvParse(data, parser);
}
function useDataSource(url, parser = autoType) {
  const hasUrl = Boolean(url);
  return useQuery({
    queryKey: url || "nullQuery",
    queryFn: async () => {
      if (!hasUrl)
        return Promise.reject("No URL provided");
      const data = await fetchDataSource(url, parser);
      return data;
    },
    enabled: hasUrl,
    retry: hasUrl ? 3 : false
  });
}
const DEFAULT_PARSERS = {
  app: (row) => {
    switch (row.id) {
      case "year":
      case "default_year":
        return {
          id: row.id,
          value: parseValues(row.value, { type: "string" })
        };
      case "default_viewport":
        return { id: row.id, value: parseValues(row.value, { type: "float" }) };
      default:
        return { id: row.id, value: parseValues(row.value) };
    }
  },
  regions: autoType,
  metrics: (row) => {
    return {
      id: row.id,
      name: row.name,
      description: row.description,
      source: row.source,
      link: row.link,
      category: parseValues(row.category),
      subcategory: parseValues(row.subcategory),
      formatter: getFormatter(row.format),
      exclude_regions: parseValues(row.exclude_regions)
    };
  },
  subgroups: autoType,
  data_sources: (row) => {
    return {
      id: row.id,
      region_id: parseValues(row.region_id),
      metric_id: parseValues(row.metric_id),
      subgroup_id: parseValues(row.subgroup_id),
      year: parseValues(row.year, { type: "string" }),
      url: row.url,
      _meta: {
        originalId: row.id,
        idParts: row.id.split("_"),
        idStructure: ["region_id", "metric_id", "subgroup_id", "year"]
      }
    };
  },
  map_layers: (row) => {
    return {
      id: parseId(row.id),
      region_id: parseValues(row.region_id),
      metric_id: parseValues(row.metric_id),
      subgroup_id: parseValues(row.subgroup_id),
      year: parseValues(row.year, { type: "string" }),
      type: row.type,
      source: row.source,
      source_type: row.source_type,
      source_layer: row.source_layer,
      _meta: {
        originalId: row.id,
        idParts: row.id.split("_"),
        idStructure: ["region_id", "type", "year"]
      }
    };
  },
  metric_scales: (row) => {
    return {
      id: parseId(row.id),
      region_id: parseValues(row.region_id),
      metric_id: parseValues(row.metric_id),
      subgroup_id: parseValues(row.subgroup_id),
      year: parseValues(row.year, { type: "string" }),
      scale: row.scale,
      chunks: parseValues(row.chunks),
      min_quantile: parseValue(row.min_quantile),
      max_quantile: parseValue(row.max_quantile),
      min_extent: parseValue(row.min_extent),
      max_extent: parseValue(row.max_extent),
      colors: parseValues(row.colors),
      _meta: {
        originalId: row.id,
        idParts: row.id.split("_"),
        idStructure: ["region_id", "metric_id", "subgroup_id", "year"]
      }
    };
  }
};
function getDefaultParser(configType) {
  if (!DEFAULT_PARSERS[configType]) {
    console.debug(`no parser provided for config, so config will not be parsed. (fine when using JSON config)`);
    return PASS_THROUGH;
  }
  return DEFAULT_PARSERS[configType];
}
const useConfigStore = create((set, get) => ({
  app: {},
  setApp: (app) => set({ app }),
  metrics: [],
  setMetrics: (metrics) => set({ metrics }),
  defaultMetric: null,
  setDefaultMetric: (metric) => set({ defaultMetric: metric }),
  subgroups: [],
  setSubgroups: (subgroups) => set({ subgroups }),
  regions: [],
  setRegions: (regions) => set({ regions }),
  defaultRegion: null,
  setDefaultRegion: (region) => set({ defaultRegion: region }),
  dataSources: [],
  setDataSources: [],
  scales: [],
  setScales: (scales) => set({ scales }),
  mapLayers: [],
  setMapLayers: (mapLayers) => set({ mapLayers }),
  setConfig: (type, config) => {
    set((state) => ({
      [type]: config,
      loaded: [...state.loaded, type]
    }));
  },
  loadConfig: async (type, url, options = {}) => {
    const config = await loadConfig(url, __spreadValues({ type }, options));
    console.debug(`loaded ${type} config`, config);
    set((state) => ({
      [type]: config,
      loaded: [...state.loaded, type]
    }));
    return { type, config };
  },
  loaded: [],
  setLoaded: (loaded) => set({ loaded }),
  getConfig: (type) => get()[type],
  getAllConfig: () => ({
    app: get().app,
    metrics: get().metrics,
    subgroups: get().subgroups,
    regions: get().regions,
    dataSources: get().dataSources,
    scales: get().scales,
    mapLayers: get().mapLayers
  }),
  loading: false,
  setLoading: (loading) => set({ loading }),
  ready: false,
  setReady: (ready) => set({ ready }),
  set
}));
const getExplicitMatchCount = (values) => {
  return values.reduce((acc, value) => {
    if (value && value !== "*")
      acc = acc + 1;
    return acc;
  }, 0);
};
const getMutualKeys = (obj1, obj2) => {
  const keys = Object.keys(obj1).filter((key) => obj2[key]);
  return keys.length > 0 ? keys : null;
};
async function loadConfig(url, options = {}) {
  if (typeof url === "object" || Array.isArray(url))
    return Promise.resolve(url);
  const configType = options.type;
  const parser = options.parser || getDefaultParser(configType);
  const format2 = options.format;
  const isCsv = format2 === "csv" || url.endsWith(".csv");
  const isJson = format2 === "json" || url.endsWith(".json");
  if (!isCsv && !isJson)
    throw new Error("Invalid format provided, must be csv or json");
  return fetch(url).then((response) => {
    return isCsv ? response.text() : response.json();
  }).then((data) => {
    const configValue = isCsv ? parseCsvString(data, parser) : data;
    return configValue;
  });
}
function isMatch(configValue, actualValue) {
  if (typeof configValue !== "string" && !Array.isArray(configValue))
    return false;
  if (configValue === "*")
    return true;
  if (configValue === actualValue)
    return true;
  if (typeof configValue === "string" && configValue[0] === "/" && configValue[configValue.length - 1] === "/") {
    const regex = new RegExp(configValue.slice(1, -1));
    return regex.test(actualValue);
  }
  if (Array.isArray(configValue))
    return configValue.includes(actualValue);
  return false;
}
function getBestMatch(context = {}, entries = [], keys) {
  if (entries.length === 0)
    return null;
  keys = keys || getMutualKeys(context, entries[0]);
  if (!keys || keys.length === 0)
    return null;
  const matchingEntries = getAllMatches(context, entries, keys);
  if (matchingEntries.length === 0)
    return null;
  if (matchingEntries.length === 1)
    return matchingEntries[0];
  let matchCount = -1;
  let bestMatch = null;
  for (let i = 0; i < matchingEntries.length; i++) {
    const entry = matchingEntries[i];
    const entryValues = keys.map((key) => entry[key]);
    const entryMatchCount = getExplicitMatchCount(entryValues);
    if (entryMatchCount < matchCount)
      continue;
    matchCount = entryMatchCount;
    bestMatch = entry;
  }
  return bestMatch;
}
function getAllMatches(context = {}, entries = [], keys) {
  keys = keys || Object.keys(context);
  if (entries.length === 0 || keys.length === 0)
    return null;
  const matches = entries.filter((entry) => {
    return keys.reduce((matched, key) => {
      if (!matched)
        return false;
      return isMatch(entry[key], context[key]);
    }, true);
  });
  return matches;
}
function useBubbleOptions() {
  const metricConfig = useMetricConfig();
  return useMemo(() => {
    return metricConfig.filter((m2) => m2.type === "bubble");
  }, [metricConfig]);
}
function useCurrentContext() {
  const [bubbleMetric, choroplethMetric, subgroup, region, year2] = useDashboardStore((state) => [
    state.bubbleMetric,
    state.choroplethMetric,
    state.subgroup,
    state.region,
    state.year
  ], shallow);
  return useMemo(() => {
    return {
      bubbleMetric,
      choroplethMetric,
      subgroup_id: subgroup,
      region_id: region,
      year: year2
    };
  }, [bubbleMetric, choroplethMetric, subgroup, region, year2]);
}
function useBubbleContext(overrides) {
  const { bubbleMetric, subgroup_id, region_id, year: year2 } = useCurrentContext();
  return useMemo(() => {
    overrides = overrides || {};
    return {
      metric_id: bubbleMetric,
      subgroup_id,
      region_id,
      year: year2,
      type: "bubble"
    };
  }, [bubbleMetric, subgroup_id, region_id, year2, overrides]);
}
function useBubbleScale({
  context: contextOverrides,
  config: configOverrides
} = {}) {
  const accessor = useAccessor();
  const context = useBubbleContext(contextOverrides);
  const defaultColor = useAppConfig("default_bubble_colors");
  const baseScaleConfig = useScaleConfig(context);
  const scaleConfig = configOverrides ? __spreadValues(__spreadValues({}, baseScaleConfig), configOverrides) : baseScaleConfig;
  const {
    extent_data,
    extent_min_key,
    extent_max_key,
    min,
    max,
    min_size,
    max_size,
    chunks,
    colors
  } = scaleConfig;
  const extentsUrl = extent_data && interpolateString(extent_data, context);
  const { isSuccess, data } = useDataSource(extentsUrl);
  const { format: format2, short_format } = useMetricConfig(context.metric_id);
  const formatType = short_format || format2 || "number";
  const formatLabel = getFormatter(formatType);
  const metricEntry = isSuccess && (data == null ? void 0 : data.find((entry) => entry.id === accessor(context)));
  const minValue = metricEntry && metricEntry[extent_min_key] || min || 0;
  const maxValue = metricEntry && metricEntry[extent_max_key] || max || 1;
  const colorValue = colors || defaultColor;
  const scaleFns = getScale("bubble", {
    min: minValue,
    max: maxValue,
    minSize: min_size,
    maxSize: max_size,
    chunks,
    colors: colorValue
  });
  return __spreadValues({
    ScaleProps: {
      type: "bubble",
      min: minValue,
      max: maxValue,
      colors: colorValue,
      chunks
    },
    BubbleProps: {
      minSize: min_size,
      maxSize: max_size,
      formatLabel
    }
  }, scaleFns);
}
function useBubbleMetric() {
  const { bubbleMetric } = useCurrentContext();
  return useMetricConfig(bubbleMetric);
}
function useChoroplethScale({
  context: contextOverrides,
  config: configOverrides
} = {}) {
  const context = useChoroplethContext(contextOverrides);
  const accessor = useAccessor();
  const defaultColor = useAppConfig("default_choropleth_colors");
  const baseScaleConfig = useScaleConfig(context);
  const scaleConfig = configOverrides ? __spreadValues(__spreadValues({}, baseScaleConfig), configOverrides) : baseScaleConfig;
  const {
    extent_data,
    extent_min_key,
    extent_max_key,
    min,
    max,
    chunks,
    scale,
    colors
  } = scaleConfig;
  const extentsUrl = extent_data && interpolateString(extent_data, context);
  const { isSuccess, data } = useDataSource(extentsUrl);
  const { format: format2, short_format } = useMetricConfig(context.metric_id);
  const formatType = short_format || format2 || "number";
  const tickFormat = getFormatter(formatType);
  const metricEntry = isSuccess && (data == null ? void 0 : data.find((entry) => entry.id === accessor(context)));
  const minValue = metricEntry && metricEntry[extent_min_key] || min || 0;
  const maxValue = metricEntry && metricEntry[extent_max_key] || max || 1;
  const colorValue = colors || defaultColor;
  const scaleFns = getScale(scale, {
    min: minValue,
    max: maxValue,
    chunks,
    colors: colorValue
  });
  const TickProps = { tickFormat };
  if (scaleFns == null ? void 0 : scaleFns.chunks) {
    TickProps.endTicks = true;
    TickProps.tickValues = scaleFns.chunks.reduce((tickValues, chunk, i) => {
      if (i === 0)
        return tickValues;
      if (i === scaleFns.chunks.length - 1)
        return [...tickValues, chunk.value[0]];
      return [...tickValues, ...chunk.value];
    }, []);
  } else {
    TickProps.ticks = chunks || 5;
  }
  return __spreadValues({
    ScaleProps: {
      type: scale,
      min: minValue,
      max: maxValue,
      colors: colorValue,
      chunks
    },
    TickProps
  }, scaleFns);
}
function useChoroplethOptions() {
  const metricConfig = useMetricConfig();
  return useMemo(() => {
    return metricConfig.filter((m2) => m2.type === "choropleth");
  }, [metricConfig]);
}
function useChoroplethMetric() {
  const { choroplethMetric } = useCurrentContext();
  return useMetricConfig(choroplethMetric);
}
function useChoroplethContext(overrides) {
  const { choroplethMetric, subgroup_id, region_id, year: year2 } = useCurrentContext();
  return useMemo(() => {
    overrides = overrides || {};
    return __spreadValues({
      metric_id: choroplethMetric,
      subgroup_id,
      region_id,
      year: year2,
      type: "choropleth"
    }, overrides);
  }, [choroplethMetric, subgroup_id, region_id, year2, overrides]);
}
function useDashboardState(key) {
  return useDashboardStore((state) => state[key]);
}
function useRegionOptions() {
  return useRegionConfig();
}
function useSubgroupOptions() {
  return useSubgroupConfig();
}
function useYearOptions() {
  const years = useAppConfig("years");
  return useMemo(() => {
    return years.map((y) => {
      return {
        id: y,
        name: y
      };
    });
  }, [years]);
}
function useMapSources() {
  const currentContext = useCurrentContext();
  const _a = currentContext, { bubbleMetric, choroplethMetric } = _a, restContext = __objRest(_a, ["bubbleMetric", "choroplethMetric"]);
  const choroplethSources = useMapSourceConfig(__spreadValues({
    metric_id: choroplethMetric
  }, restContext));
  const bubbleSources = useMapSourceConfig(__spreadValues({
    metric_id: bubbleMetric
  }, restContext));
  return useMemo(() => {
    return [...choroplethSources, ...bubbleSources].reduce((uniqueSources, current) => {
      if (uniqueSources.find((source2) => source2.id === current.id))
        return uniqueSources;
      const _a2 = current, { region_id, metric_id, subgroup_id, year: year2 } = _a2, source = __objRest(_a2, ["region_id", "metric_id", "subgroup_id", "year"]);
      uniqueSources.push(source);
      return uniqueSources;
    }, []);
  }, [choroplethSources, bubbleSources]);
}
var colorString$1 = { exports: {} };
var colorName = {
  "aliceblue": [240, 248, 255],
  "antiquewhite": [250, 235, 215],
  "aqua": [0, 255, 255],
  "aquamarine": [127, 255, 212],
  "azure": [240, 255, 255],
  "beige": [245, 245, 220],
  "bisque": [255, 228, 196],
  "black": [0, 0, 0],
  "blanchedalmond": [255, 235, 205],
  "blue": [0, 0, 255],
  "blueviolet": [138, 43, 226],
  "brown": [165, 42, 42],
  "burlywood": [222, 184, 135],
  "cadetblue": [95, 158, 160],
  "chartreuse": [127, 255, 0],
  "chocolate": [210, 105, 30],
  "coral": [255, 127, 80],
  "cornflowerblue": [100, 149, 237],
  "cornsilk": [255, 248, 220],
  "crimson": [220, 20, 60],
  "cyan": [0, 255, 255],
  "darkblue": [0, 0, 139],
  "darkcyan": [0, 139, 139],
  "darkgoldenrod": [184, 134, 11],
  "darkgray": [169, 169, 169],
  "darkgreen": [0, 100, 0],
  "darkgrey": [169, 169, 169],
  "darkkhaki": [189, 183, 107],
  "darkmagenta": [139, 0, 139],
  "darkolivegreen": [85, 107, 47],
  "darkorange": [255, 140, 0],
  "darkorchid": [153, 50, 204],
  "darkred": [139, 0, 0],
  "darksalmon": [233, 150, 122],
  "darkseagreen": [143, 188, 143],
  "darkslateblue": [72, 61, 139],
  "darkslategray": [47, 79, 79],
  "darkslategrey": [47, 79, 79],
  "darkturquoise": [0, 206, 209],
  "darkviolet": [148, 0, 211],
  "deeppink": [255, 20, 147],
  "deepskyblue": [0, 191, 255],
  "dimgray": [105, 105, 105],
  "dimgrey": [105, 105, 105],
  "dodgerblue": [30, 144, 255],
  "firebrick": [178, 34, 34],
  "floralwhite": [255, 250, 240],
  "forestgreen": [34, 139, 34],
  "fuchsia": [255, 0, 255],
  "gainsboro": [220, 220, 220],
  "ghostwhite": [248, 248, 255],
  "gold": [255, 215, 0],
  "goldenrod": [218, 165, 32],
  "gray": [128, 128, 128],
  "green": [0, 128, 0],
  "greenyellow": [173, 255, 47],
  "grey": [128, 128, 128],
  "honeydew": [240, 255, 240],
  "hotpink": [255, 105, 180],
  "indianred": [205, 92, 92],
  "indigo": [75, 0, 130],
  "ivory": [255, 255, 240],
  "khaki": [240, 230, 140],
  "lavender": [230, 230, 250],
  "lavenderblush": [255, 240, 245],
  "lawngreen": [124, 252, 0],
  "lemonchiffon": [255, 250, 205],
  "lightblue": [173, 216, 230],
  "lightcoral": [240, 128, 128],
  "lightcyan": [224, 255, 255],
  "lightgoldenrodyellow": [250, 250, 210],
  "lightgray": [211, 211, 211],
  "lightgreen": [144, 238, 144],
  "lightgrey": [211, 211, 211],
  "lightpink": [255, 182, 193],
  "lightsalmon": [255, 160, 122],
  "lightseagreen": [32, 178, 170],
  "lightskyblue": [135, 206, 250],
  "lightslategray": [119, 136, 153],
  "lightslategrey": [119, 136, 153],
  "lightsteelblue": [176, 196, 222],
  "lightyellow": [255, 255, 224],
  "lime": [0, 255, 0],
  "limegreen": [50, 205, 50],
  "linen": [250, 240, 230],
  "magenta": [255, 0, 255],
  "maroon": [128, 0, 0],
  "mediumaquamarine": [102, 205, 170],
  "mediumblue": [0, 0, 205],
  "mediumorchid": [186, 85, 211],
  "mediumpurple": [147, 112, 219],
  "mediumseagreen": [60, 179, 113],
  "mediumslateblue": [123, 104, 238],
  "mediumspringgreen": [0, 250, 154],
  "mediumturquoise": [72, 209, 204],
  "mediumvioletred": [199, 21, 133],
  "midnightblue": [25, 25, 112],
  "mintcream": [245, 255, 250],
  "mistyrose": [255, 228, 225],
  "moccasin": [255, 228, 181],
  "navajowhite": [255, 222, 173],
  "navy": [0, 0, 128],
  "oldlace": [253, 245, 230],
  "olive": [128, 128, 0],
  "olivedrab": [107, 142, 35],
  "orange": [255, 165, 0],
  "orangered": [255, 69, 0],
  "orchid": [218, 112, 214],
  "palegoldenrod": [238, 232, 170],
  "palegreen": [152, 251, 152],
  "paleturquoise": [175, 238, 238],
  "palevioletred": [219, 112, 147],
  "papayawhip": [255, 239, 213],
  "peachpuff": [255, 218, 185],
  "peru": [205, 133, 63],
  "pink": [255, 192, 203],
  "plum": [221, 160, 221],
  "powderblue": [176, 224, 230],
  "purple": [128, 0, 128],
  "rebeccapurple": [102, 51, 153],
  "red": [255, 0, 0],
  "rosybrown": [188, 143, 143],
  "royalblue": [65, 105, 225],
  "saddlebrown": [139, 69, 19],
  "salmon": [250, 128, 114],
  "sandybrown": [244, 164, 96],
  "seagreen": [46, 139, 87],
  "seashell": [255, 245, 238],
  "sienna": [160, 82, 45],
  "silver": [192, 192, 192],
  "skyblue": [135, 206, 235],
  "slateblue": [106, 90, 205],
  "slategray": [112, 128, 144],
  "slategrey": [112, 128, 144],
  "snow": [255, 250, 250],
  "springgreen": [0, 255, 127],
  "steelblue": [70, 130, 180],
  "tan": [210, 180, 140],
  "teal": [0, 128, 128],
  "thistle": [216, 191, 216],
  "tomato": [255, 99, 71],
  "turquoise": [64, 224, 208],
  "violet": [238, 130, 238],
  "wheat": [245, 222, 179],
  "white": [255, 255, 255],
  "whitesmoke": [245, 245, 245],
  "yellow": [255, 255, 0],
  "yellowgreen": [154, 205, 50]
};
var simpleSwizzle = { exports: {} };
var isArrayish$1 = function isArrayish(obj) {
  if (!obj || typeof obj === "string") {
    return false;
  }
  return obj instanceof Array || Array.isArray(obj) || obj.length >= 0 && (obj.splice instanceof Function || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== "String");
};
var isArrayish2 = isArrayish$1;
var concat = Array.prototype.concat;
var slice = Array.prototype.slice;
var swizzle$1 = simpleSwizzle.exports = function swizzle(args) {
  var results = [];
  for (var i = 0, len = args.length; i < len; i++) {
    var arg = args[i];
    if (isArrayish2(arg)) {
      results = concat.call(results, slice.call(arg));
    } else {
      results.push(arg);
    }
  }
  return results;
};
swizzle$1.wrap = function(fn) {
  return function() {
    return fn(swizzle$1(arguments));
  };
};
var colorNames = colorName;
var swizzle2 = simpleSwizzle.exports;
var hasOwnProperty$1 = Object.hasOwnProperty;
var reverseNames = {};
for (var name in colorNames) {
  if (hasOwnProperty$1.call(colorNames, name)) {
    reverseNames[colorNames[name]] = name;
  }
}
var cs = colorString$1.exports = {
  to: {},
  get: {}
};
cs.get = function(string) {
  var prefix = string.substring(0, 3).toLowerCase();
  var val;
  var model;
  switch (prefix) {
    case "hsl":
      val = cs.get.hsl(string);
      model = "hsl";
      break;
    case "hwb":
      val = cs.get.hwb(string);
      model = "hwb";
      break;
    default:
      val = cs.get.rgb(string);
      model = "rgb";
      break;
  }
  if (!val) {
    return null;
  }
  return { model, value: val };
};
cs.get.rgb = function(string) {
  if (!string) {
    return null;
  }
  var abbr = /^#([a-f0-9]{3,4})$/i;
  var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
  var rgba = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
  var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
  var keyword = /^(\w+)$/;
  var rgb = [0, 0, 0, 1];
  var match;
  var i;
  var hexAlpha;
  if (match = string.match(hex)) {
    hexAlpha = match[2];
    match = match[1];
    for (i = 0; i < 3; i++) {
      var i2 = i * 2;
      rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
    }
    if (hexAlpha) {
      rgb[3] = parseInt(hexAlpha, 16) / 255;
    }
  } else if (match = string.match(abbr)) {
    match = match[1];
    hexAlpha = match[3];
    for (i = 0; i < 3; i++) {
      rgb[i] = parseInt(match[i] + match[i], 16);
    }
    if (hexAlpha) {
      rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
    }
  } else if (match = string.match(rgba)) {
    for (i = 0; i < 3; i++) {
      rgb[i] = parseInt(match[i + 1], 0);
    }
    if (match[4]) {
      if (match[5]) {
        rgb[3] = parseFloat(match[4]) * 0.01;
      } else {
        rgb[3] = parseFloat(match[4]);
      }
    }
  } else if (match = string.match(per)) {
    for (i = 0; i < 3; i++) {
      rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
    }
    if (match[4]) {
      if (match[5]) {
        rgb[3] = parseFloat(match[4]) * 0.01;
      } else {
        rgb[3] = parseFloat(match[4]);
      }
    }
  } else if (match = string.match(keyword)) {
    if (match[1] === "transparent") {
      return [0, 0, 0, 0];
    }
    if (!hasOwnProperty$1.call(colorNames, match[1])) {
      return null;
    }
    rgb = colorNames[match[1]];
    rgb[3] = 1;
    return rgb;
  } else {
    return null;
  }
  for (i = 0; i < 3; i++) {
    rgb[i] = clamp(rgb[i], 0, 255);
  }
  rgb[3] = clamp(rgb[3], 0, 1);
  return rgb;
};
cs.get.hsl = function(string) {
  if (!string) {
    return null;
  }
  var hsl = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
  var match = string.match(hsl);
  if (match) {
    var alpha = parseFloat(match[4]);
    var h = (parseFloat(match[1]) % 360 + 360) % 360;
    var s = clamp(parseFloat(match[2]), 0, 100);
    var l = clamp(parseFloat(match[3]), 0, 100);
    var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
    return [h, s, l, a];
  }
  return null;
};
cs.get.hwb = function(string) {
  if (!string) {
    return null;
  }
  var hwb = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
  var match = string.match(hwb);
  if (match) {
    var alpha = parseFloat(match[4]);
    var h = (parseFloat(match[1]) % 360 + 360) % 360;
    var w = clamp(parseFloat(match[2]), 0, 100);
    var b = clamp(parseFloat(match[3]), 0, 100);
    var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
    return [h, w, b, a];
  }
  return null;
};
cs.to.hex = function() {
  var rgba = swizzle2(arguments);
  return "#" + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (rgba[3] < 1 ? hexDouble(Math.round(rgba[3] * 255)) : "");
};
cs.to.rgb = function() {
  var rgba = swizzle2(arguments);
  return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ")" : "rgba(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ", " + rgba[3] + ")";
};
cs.to.rgb.percent = function() {
  var rgba = swizzle2(arguments);
  var r = Math.round(rgba[0] / 255 * 100);
  var g2 = Math.round(rgba[1] / 255 * 100);
  var b = Math.round(rgba[2] / 255 * 100);
  return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + r + "%, " + g2 + "%, " + b + "%)" : "rgba(" + r + "%, " + g2 + "%, " + b + "%, " + rgba[3] + ")";
};
cs.to.hsl = function() {
  var hsla = swizzle2(arguments);
  return hsla.length < 4 || hsla[3] === 1 ? "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)" : "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + hsla[3] + ")";
};
cs.to.hwb = function() {
  var hwba = swizzle2(arguments);
  var a = "";
  if (hwba.length >= 4 && hwba[3] !== 1) {
    a = ", " + hwba[3];
  }
  return "hwb(" + hwba[0] + ", " + hwba[1] + "%, " + hwba[2] + "%" + a + ")";
};
cs.to.keyword = function(rgb) {
  return reverseNames[rgb.slice(0, 3)];
};
function clamp(num, min, max) {
  return Math.min(Math.max(min, num), max);
}
function hexDouble(num) {
  var str = Math.round(num).toString(16).toUpperCase();
  return str.length < 2 ? "0" + str : str;
}
const cssKeywords = colorName;
const reverseKeywords = {};
for (const key of Object.keys(cssKeywords)) {
  reverseKeywords[cssKeywords[key]] = key;
}
const convert$2 = {
  rgb: { channels: 3, labels: "rgb" },
  hsl: { channels: 3, labels: "hsl" },
  hsv: { channels: 3, labels: "hsv" },
  hwb: { channels: 3, labels: "hwb" },
  cmyk: { channels: 4, labels: "cmyk" },
  xyz: { channels: 3, labels: "xyz" },
  lab: { channels: 3, labels: "lab" },
  lch: { channels: 3, labels: "lch" },
  hex: { channels: 1, labels: ["hex"] },
  keyword: { channels: 1, labels: ["keyword"] },
  ansi16: { channels: 1, labels: ["ansi16"] },
  ansi256: { channels: 1, labels: ["ansi256"] },
  hcg: { channels: 3, labels: ["h", "c", "g"] },
  apple: { channels: 3, labels: ["r16", "g16", "b16"] },
  gray: { channels: 1, labels: ["gray"] }
};
var conversions$2 = convert$2;
for (const model of Object.keys(convert$2)) {
  if (!("channels" in convert$2[model])) {
    throw new Error("missing channels property: " + model);
  }
  if (!("labels" in convert$2[model])) {
    throw new Error("missing channel labels property: " + model);
  }
  if (convert$2[model].labels.length !== convert$2[model].channels) {
    throw new Error("channel and label counts mismatch: " + model);
  }
  const { channels, labels } = convert$2[model];
  delete convert$2[model].channels;
  delete convert$2[model].labels;
  Object.defineProperty(convert$2[model], "channels", { value: channels });
  Object.defineProperty(convert$2[model], "labels", { value: labels });
}
convert$2.rgb.hsl = function(rgb) {
  const r = rgb[0] / 255;
  const g2 = rgb[1] / 255;
  const b = rgb[2] / 255;
  const min = Math.min(r, g2, b);
  const max = Math.max(r, g2, b);
  const delta = max - min;
  let h;
  let s;
  if (max === min) {
    h = 0;
  } else if (r === max) {
    h = (g2 - b) / delta;
  } else if (g2 === max) {
    h = 2 + (b - r) / delta;
  } else if (b === max) {
    h = 4 + (r - g2) / delta;
  }
  h = Math.min(h * 60, 360);
  if (h < 0) {
    h += 360;
  }
  const l = (min + max) / 2;
  if (max === min) {
    s = 0;
  } else if (l <= 0.5) {
    s = delta / (max + min);
  } else {
    s = delta / (2 - max - min);
  }
  return [h, s * 100, l * 100];
};
convert$2.rgb.hsv = function(rgb) {
  let rdif;
  let gdif;
  let bdif;
  let h;
  let s;
  const r = rgb[0] / 255;
  const g2 = rgb[1] / 255;
  const b = rgb[2] / 255;
  const v = Math.max(r, g2, b);
  const diff = v - Math.min(r, g2, b);
  const diffc = function(c) {
    return (v - c) / 6 / diff + 1 / 2;
  };
  if (diff === 0) {
    h = 0;
    s = 0;
  } else {
    s = diff / v;
    rdif = diffc(r);
    gdif = diffc(g2);
    bdif = diffc(b);
    if (r === v) {
      h = bdif - gdif;
    } else if (g2 === v) {
      h = 1 / 3 + rdif - bdif;
    } else if (b === v) {
      h = 2 / 3 + gdif - rdif;
    }
    if (h < 0) {
      h += 1;
    } else if (h > 1) {
      h -= 1;
    }
  }
  return [
    h * 360,
    s * 100,
    v * 100
  ];
};
convert$2.rgb.hwb = function(rgb) {
  const r = rgb[0];
  const g2 = rgb[1];
  let b = rgb[2];
  const h = convert$2.rgb.hsl(rgb)[0];
  const w = 1 / 255 * Math.min(r, Math.min(g2, b));
  b = 1 - 1 / 255 * Math.max(r, Math.max(g2, b));
  return [h, w * 100, b * 100];
};
convert$2.rgb.cmyk = function(rgb) {
  const r = rgb[0] / 255;
  const g2 = rgb[1] / 255;
  const b = rgb[2] / 255;
  const k = Math.min(1 - r, 1 - g2, 1 - b);
  const c = (1 - r - k) / (1 - k) || 0;
  const m2 = (1 - g2 - k) / (1 - k) || 0;
  const y = (1 - b - k) / (1 - k) || 0;
  return [c * 100, m2 * 100, y * 100, k * 100];
};
function comparativeDistance(x, y) {
  return (x[0] - y[0]) ** 2 + (x[1] - y[1]) ** 2 + (x[2] - y[2]) ** 2;
}
convert$2.rgb.keyword = function(rgb) {
  const reversed = reverseKeywords[rgb];
  if (reversed) {
    return reversed;
  }
  let currentClosestDistance = Infinity;
  let currentClosestKeyword;
  for (const keyword of Object.keys(cssKeywords)) {
    const value = cssKeywords[keyword];
    const distance = comparativeDistance(rgb, value);
    if (distance < currentClosestDistance) {
      currentClosestDistance = distance;
      currentClosestKeyword = keyword;
    }
  }
  return currentClosestKeyword;
};
convert$2.keyword.rgb = function(keyword) {
  return cssKeywords[keyword];
};
convert$2.rgb.xyz = function(rgb) {
  let r = rgb[0] / 255;
  let g2 = rgb[1] / 255;
  let b = rgb[2] / 255;
  r = r > 0.04045 ? ((r + 0.055) / 1.055) ** 2.4 : r / 12.92;
  g2 = g2 > 0.04045 ? ((g2 + 0.055) / 1.055) ** 2.4 : g2 / 12.92;
  b = b > 0.04045 ? ((b + 0.055) / 1.055) ** 2.4 : b / 12.92;
  const x = r * 0.4124 + g2 * 0.3576 + b * 0.1805;
  const y = r * 0.2126 + g2 * 0.7152 + b * 0.0722;
  const z = r * 0.0193 + g2 * 0.1192 + b * 0.9505;
  return [x * 100, y * 100, z * 100];
};
convert$2.rgb.lab = function(rgb) {
  const xyz = convert$2.rgb.xyz(rgb);
  let x = xyz[0];
  let y = xyz[1];
  let z = xyz[2];
  x /= 95.047;
  y /= 100;
  z /= 108.883;
  x = x > 8856e-6 ? x ** (1 / 3) : 7.787 * x + 16 / 116;
  y = y > 8856e-6 ? y ** (1 / 3) : 7.787 * y + 16 / 116;
  z = z > 8856e-6 ? z ** (1 / 3) : 7.787 * z + 16 / 116;
  const l = 116 * y - 16;
  const a = 500 * (x - y);
  const b = 200 * (y - z);
  return [l, a, b];
};
convert$2.hsl.rgb = function(hsl) {
  const h = hsl[0] / 360;
  const s = hsl[1] / 100;
  const l = hsl[2] / 100;
  let t2;
  let t3;
  let val;
  if (s === 0) {
    val = l * 255;
    return [val, val, val];
  }
  if (l < 0.5) {
    t2 = l * (1 + s);
  } else {
    t2 = l + s - l * s;
  }
  const t12 = 2 * l - t2;
  const rgb = [0, 0, 0];
  for (let i = 0; i < 3; i++) {
    t3 = h + 1 / 3 * -(i - 1);
    if (t3 < 0) {
      t3++;
    }
    if (t3 > 1) {
      t3--;
    }
    if (6 * t3 < 1) {
      val = t12 + (t2 - t12) * 6 * t3;
    } else if (2 * t3 < 1) {
      val = t2;
    } else if (3 * t3 < 2) {
      val = t12 + (t2 - t12) * (2 / 3 - t3) * 6;
    } else {
      val = t12;
    }
    rgb[i] = val * 255;
  }
  return rgb;
};
convert$2.hsl.hsv = function(hsl) {
  const h = hsl[0];
  let s = hsl[1] / 100;
  let l = hsl[2] / 100;
  let smin = s;
  const lmin = Math.max(l, 0.01);
  l *= 2;
  s *= l <= 1 ? l : 2 - l;
  smin *= lmin <= 1 ? lmin : 2 - lmin;
  const v = (l + s) / 2;
  const sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
  return [h, sv * 100, v * 100];
};
convert$2.hsv.rgb = function(hsv) {
  const h = hsv[0] / 60;
  const s = hsv[1] / 100;
  let v = hsv[2] / 100;
  const hi = Math.floor(h) % 6;
  const f2 = h - Math.floor(h);
  const p2 = 255 * v * (1 - s);
  const q2 = 255 * v * (1 - s * f2);
  const t = 255 * v * (1 - s * (1 - f2));
  v *= 255;
  switch (hi) {
    case 0:
      return [v, t, p2];
    case 1:
      return [q2, v, p2];
    case 2:
      return [p2, v, t];
    case 3:
      return [p2, q2, v];
    case 4:
      return [t, p2, v];
    case 5:
      return [v, p2, q2];
  }
};
convert$2.hsv.hsl = function(hsv) {
  const h = hsv[0];
  const s = hsv[1] / 100;
  const v = hsv[2] / 100;
  const vmin = Math.max(v, 0.01);
  let sl;
  let l;
  l = (2 - s) * v;
  const lmin = (2 - s) * vmin;
  sl = s * vmin;
  sl /= lmin <= 1 ? lmin : 2 - lmin;
  sl = sl || 0;
  l /= 2;
  return [h, sl * 100, l * 100];
};
convert$2.hwb.rgb = function(hwb) {
  const h = hwb[0] / 360;
  let wh = hwb[1] / 100;
  let bl = hwb[2] / 100;
  const ratio = wh + bl;
  let f2;
  if (ratio > 1) {
    wh /= ratio;
    bl /= ratio;
  }
  const i = Math.floor(6 * h);
  const v = 1 - bl;
  f2 = 6 * h - i;
  if ((i & 1) !== 0) {
    f2 = 1 - f2;
  }
  const n2 = wh + f2 * (v - wh);
  let r;
  let g2;
  let b;
  switch (i) {
    default:
    case 6:
    case 0:
      r = v;
      g2 = n2;
      b = wh;
      break;
    case 1:
      r = n2;
      g2 = v;
      b = wh;
      break;
    case 2:
      r = wh;
      g2 = v;
      b = n2;
      break;
    case 3:
      r = wh;
      g2 = n2;
      b = v;
      break;
    case 4:
      r = n2;
      g2 = wh;
      b = v;
      break;
    case 5:
      r = v;
      g2 = wh;
      b = n2;
      break;
  }
  return [r * 255, g2 * 255, b * 255];
};
convert$2.cmyk.rgb = function(cmyk) {
  const c = cmyk[0] / 100;
  const m2 = cmyk[1] / 100;
  const y = cmyk[2] / 100;
  const k = cmyk[3] / 100;
  const r = 1 - Math.min(1, c * (1 - k) + k);
  const g2 = 1 - Math.min(1, m2 * (1 - k) + k);
  const b = 1 - Math.min(1, y * (1 - k) + k);
  return [r * 255, g2 * 255, b * 255];
};
convert$2.xyz.rgb = function(xyz) {
  const x = xyz[0] / 100;
  const y = xyz[1] / 100;
  const z = xyz[2] / 100;
  let r;
  let g2;
  let b;
  r = x * 3.2406 + y * -1.5372 + z * -0.4986;
  g2 = x * -0.9689 + y * 1.8758 + z * 0.0415;
  b = x * 0.0557 + y * -0.204 + z * 1.057;
  r = r > 31308e-7 ? 1.055 * r ** (1 / 2.4) - 0.055 : r * 12.92;
  g2 = g2 > 31308e-7 ? 1.055 * g2 ** (1 / 2.4) - 0.055 : g2 * 12.92;
  b = b > 31308e-7 ? 1.055 * b ** (1 / 2.4) - 0.055 : b * 12.92;
  r = Math.min(Math.max(0, r), 1);
  g2 = Math.min(Math.max(0, g2), 1);
  b = Math.min(Math.max(0, b), 1);
  return [r * 255, g2 * 255, b * 255];
};
convert$2.xyz.lab = function(xyz) {
  let x = xyz[0];
  let y = xyz[1];
  let z = xyz[2];
  x /= 95.047;
  y /= 100;
  z /= 108.883;
  x = x > 8856e-6 ? x ** (1 / 3) : 7.787 * x + 16 / 116;
  y = y > 8856e-6 ? y ** (1 / 3) : 7.787 * y + 16 / 116;
  z = z > 8856e-6 ? z ** (1 / 3) : 7.787 * z + 16 / 116;
  const l = 116 * y - 16;
  const a = 500 * (x - y);
  const b = 200 * (y - z);
  return [l, a, b];
};
convert$2.lab.xyz = function(lab) {
  const l = lab[0];
  const a = lab[1];
  const b = lab[2];
  let x;
  let y;
  let z;
  y = (l + 16) / 116;
  x = a / 500 + y;
  z = y - b / 200;
  const y2 = y ** 3;
  const x2 = x ** 3;
  const z2 = z ** 3;
  y = y2 > 8856e-6 ? y2 : (y - 16 / 116) / 7.787;
  x = x2 > 8856e-6 ? x2 : (x - 16 / 116) / 7.787;
  z = z2 > 8856e-6 ? z2 : (z - 16 / 116) / 7.787;
  x *= 95.047;
  y *= 100;
  z *= 108.883;
  return [x, y, z];
};
convert$2.lab.lch = function(lab) {
  const l = lab[0];
  const a = lab[1];
  const b = lab[2];
  let h;
  const hr = Math.atan2(b, a);
  h = hr * 360 / 2 / Math.PI;
  if (h < 0) {
    h += 360;
  }
  const c = Math.sqrt(a * a + b * b);
  return [l, c, h];
};
convert$2.lch.lab = function(lch) {
  const l = lch[0];
  const c = lch[1];
  const h = lch[2];
  const hr = h / 360 * 2 * Math.PI;
  const a = c * Math.cos(hr);
  const b = c * Math.sin(hr);
  return [l, a, b];
};
convert$2.rgb.ansi16 = function(args, saturation = null) {
  const [r, g2, b] = args;
  let value = saturation === null ? convert$2.rgb.hsv(args)[2] : saturation;
  value = Math.round(value / 50);
  if (value === 0) {
    return 30;
  }
  let ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g2 / 255) << 1 | Math.round(r / 255));
  if (value === 2) {
    ansi += 60;
  }
  return ansi;
};
convert$2.hsv.ansi16 = function(args) {
  return convert$2.rgb.ansi16(convert$2.hsv.rgb(args), args[2]);
};
convert$2.rgb.ansi256 = function(args) {
  const r = args[0];
  const g2 = args[1];
  const b = args[2];
  if (r === g2 && g2 === b) {
    if (r < 8) {
      return 16;
    }
    if (r > 248) {
      return 231;
    }
    return Math.round((r - 8) / 247 * 24) + 232;
  }
  const ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g2 / 255 * 5) + Math.round(b / 255 * 5);
  return ansi;
};
convert$2.ansi16.rgb = function(args) {
  let color2 = args % 10;
  if (color2 === 0 || color2 === 7) {
    if (args > 50) {
      color2 += 3.5;
    }
    color2 = color2 / 10.5 * 255;
    return [color2, color2, color2];
  }
  const mult = (~~(args > 50) + 1) * 0.5;
  const r = (color2 & 1) * mult * 255;
  const g2 = (color2 >> 1 & 1) * mult * 255;
  const b = (color2 >> 2 & 1) * mult * 255;
  return [r, g2, b];
};
convert$2.ansi256.rgb = function(args) {
  if (args >= 232) {
    const c = (args - 232) * 10 + 8;
    return [c, c, c];
  }
  args -= 16;
  let rem;
  const r = Math.floor(args / 36) / 5 * 255;
  const g2 = Math.floor((rem = args % 36) / 6) / 5 * 255;
  const b = rem % 6 / 5 * 255;
  return [r, g2, b];
};
convert$2.rgb.hex = function(args) {
  const integer = ((Math.round(args[0]) & 255) << 16) + ((Math.round(args[1]) & 255) << 8) + (Math.round(args[2]) & 255);
  const string = integer.toString(16).toUpperCase();
  return "000000".substring(string.length) + string;
};
convert$2.hex.rgb = function(args) {
  const match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
  if (!match) {
    return [0, 0, 0];
  }
  let colorString2 = match[0];
  if (match[0].length === 3) {
    colorString2 = colorString2.split("").map((char) => {
      return char + char;
    }).join("");
  }
  const integer = parseInt(colorString2, 16);
  const r = integer >> 16 & 255;
  const g2 = integer >> 8 & 255;
  const b = integer & 255;
  return [r, g2, b];
};
convert$2.rgb.hcg = function(rgb) {
  const r = rgb[0] / 255;
  const g2 = rgb[1] / 255;
  const b = rgb[2] / 255;
  const max = Math.max(Math.max(r, g2), b);
  const min = Math.min(Math.min(r, g2), b);
  const chroma = max - min;
  let grayscale;
  let hue;
  if (chroma < 1) {
    grayscale = min / (1 - chroma);
  } else {
    grayscale = 0;
  }
  if (chroma <= 0) {
    hue = 0;
  } else if (max === r) {
    hue = (g2 - b) / chroma % 6;
  } else if (max === g2) {
    hue = 2 + (b - r) / chroma;
  } else {
    hue = 4 + (r - g2) / chroma;
  }
  hue /= 6;
  hue %= 1;
  return [hue * 360, chroma * 100, grayscale * 100];
};
convert$2.hsl.hcg = function(hsl) {
  const s = hsl[1] / 100;
  const l = hsl[2] / 100;
  const c = l < 0.5 ? 2 * s * l : 2 * s * (1 - l);
  let f2 = 0;
  if (c < 1) {
    f2 = (l - 0.5 * c) / (1 - c);
  }
  return [hsl[0], c * 100, f2 * 100];
};
convert$2.hsv.hcg = function(hsv) {
  const s = hsv[1] / 100;
  const v = hsv[2] / 100;
  const c = s * v;
  let f2 = 0;
  if (c < 1) {
    f2 = (v - c) / (1 - c);
  }
  return [hsv[0], c * 100, f2 * 100];
};
convert$2.hcg.rgb = function(hcg) {
  const h = hcg[0] / 360;
  const c = hcg[1] / 100;
  const g2 = hcg[2] / 100;
  if (c === 0) {
    return [g2 * 255, g2 * 255, g2 * 255];
  }
  const pure = [0, 0, 0];
  const hi = h % 1 * 6;
  const v = hi % 1;
  const w = 1 - v;
  let mg = 0;
  switch (Math.floor(hi)) {
    case 0:
      pure[0] = 1;
      pure[1] = v;
      pure[2] = 0;
      break;
    case 1:
      pure[0] = w;
      pure[1] = 1;
      pure[2] = 0;
      break;
    case 2:
      pure[0] = 0;
      pure[1] = 1;
      pure[2] = v;
      break;
    case 3:
      pure[0] = 0;
      pure[1] = w;
      pure[2] = 1;
      break;
    case 4:
      pure[0] = v;
      pure[1] = 0;
      pure[2] = 1;
      break;
    default:
      pure[0] = 1;
      pure[1] = 0;
      pure[2] = w;
  }
  mg = (1 - c) * g2;
  return [
    (c * pure[0] + mg) * 255,
    (c * pure[1] + mg) * 255,
    (c * pure[2] + mg) * 255
  ];
};
convert$2.hcg.hsv = function(hcg) {
  const c = hcg[1] / 100;
  const g2 = hcg[2] / 100;
  const v = c + g2 * (1 - c);
  let f2 = 0;
  if (v > 0) {
    f2 = c / v;
  }
  return [hcg[0], f2 * 100, v * 100];
};
convert$2.hcg.hsl = function(hcg) {
  const c = hcg[1] / 100;
  const g2 = hcg[2] / 100;
  const l = g2 * (1 - c) + 0.5 * c;
  let s = 0;
  if (l > 0 && l < 0.5) {
    s = c / (2 * l);
  } else if (l >= 0.5 && l < 1) {
    s = c / (2 * (1 - l));
  }
  return [hcg[0], s * 100, l * 100];
};
convert$2.hcg.hwb = function(hcg) {
  const c = hcg[1] / 100;
  const g2 = hcg[2] / 100;
  const v = c + g2 * (1 - c);
  return [hcg[0], (v - c) * 100, (1 - v) * 100];
};
convert$2.hwb.hcg = function(hwb) {
  const w = hwb[1] / 100;
  const b = hwb[2] / 100;
  const v = 1 - b;
  const c = v - w;
  let g2 = 0;
  if (c < 1) {
    g2 = (v - c) / (1 - c);
  }
  return [hwb[0], c * 100, g2 * 100];
};
convert$2.apple.rgb = function(apple) {
  return [apple[0] / 65535 * 255, apple[1] / 65535 * 255, apple[2] / 65535 * 255];
};
convert$2.rgb.apple = function(rgb) {
  return [rgb[0] / 255 * 65535, rgb[1] / 255 * 65535, rgb[2] / 255 * 65535];
};
convert$2.gray.rgb = function(args) {
  return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};
convert$2.gray.hsl = function(args) {
  return [0, 0, args[0]];
};
convert$2.gray.hsv = convert$2.gray.hsl;
convert$2.gray.hwb = function(gray) {
  return [0, 100, gray[0]];
};
convert$2.gray.cmyk = function(gray) {
  return [0, 0, 0, gray[0]];
};
convert$2.gray.lab = function(gray) {
  return [gray[0], 0, 0];
};
convert$2.gray.hex = function(gray) {
  const val = Math.round(gray[0] / 100 * 255) & 255;
  const integer = (val << 16) + (val << 8) + val;
  const string = integer.toString(16).toUpperCase();
  return "000000".substring(string.length) + string;
};
convert$2.rgb.gray = function(rgb) {
  const val = (rgb[0] + rgb[1] + rgb[2]) / 3;
  return [val / 255 * 100];
};
const conversions$1 = conversions$2;
function buildGraph() {
  const graph = {};
  const models2 = Object.keys(conversions$1);
  for (let len = models2.length, i = 0; i < len; i++) {
    graph[models2[i]] = {
      distance: -1,
      parent: null
    };
  }
  return graph;
}
function deriveBFS(fromModel) {
  const graph = buildGraph();
  const queue = [fromModel];
  graph[fromModel].distance = 0;
  while (queue.length) {
    const current = queue.pop();
    const adjacents = Object.keys(conversions$1[current]);
    for (let len = adjacents.length, i = 0; i < len; i++) {
      const adjacent = adjacents[i];
      const node = graph[adjacent];
      if (node.distance === -1) {
        node.distance = graph[current].distance + 1;
        node.parent = current;
        queue.unshift(adjacent);
      }
    }
  }
  return graph;
}
function link(from, to) {
  return function(args) {
    return to(from(args));
  };
}
function wrapConversion(toModel, graph) {
  const path = [graph[toModel].parent, toModel];
  let fn = conversions$1[graph[toModel].parent][toModel];
  let cur = graph[toModel].parent;
  while (graph[cur].parent) {
    path.unshift(graph[cur].parent);
    fn = link(conversions$1[graph[cur].parent][cur], fn);
    cur = graph[cur].parent;
  }
  fn.conversion = path;
  return fn;
}
var route$1 = function(fromModel) {
  const graph = deriveBFS(fromModel);
  const conversion = {};
  const models2 = Object.keys(graph);
  for (let len = models2.length, i = 0; i < len; i++) {
    const toModel = models2[i];
    const node = graph[toModel];
    if (node.parent === null) {
      continue;
    }
    conversion[toModel] = wrapConversion(toModel, graph);
  }
  return conversion;
};
const conversions = conversions$2;
const route = route$1;
const convert$1 = {};
const models = Object.keys(conversions);
function wrapRaw(fn) {
  const wrappedFn = function(...args) {
    const arg0 = args[0];
    if (arg0 === void 0 || arg0 === null) {
      return arg0;
    }
    if (arg0.length > 1) {
      args = arg0;
    }
    return fn(args);
  };
  if ("conversion" in fn) {
    wrappedFn.conversion = fn.conversion;
  }
  return wrappedFn;
}
function wrapRounded(fn) {
  const wrappedFn = function(...args) {
    const arg0 = args[0];
    if (arg0 === void 0 || arg0 === null) {
      return arg0;
    }
    if (arg0.length > 1) {
      args = arg0;
    }
    const result = fn(args);
    if (typeof result === "object") {
      for (let len = result.length, i = 0; i < len; i++) {
        result[i] = Math.round(result[i]);
      }
    }
    return result;
  };
  if ("conversion" in fn) {
    wrappedFn.conversion = fn.conversion;
  }
  return wrappedFn;
}
models.forEach((fromModel) => {
  convert$1[fromModel] = {};
  Object.defineProperty(convert$1[fromModel], "channels", { value: conversions[fromModel].channels });
  Object.defineProperty(convert$1[fromModel], "labels", { value: conversions[fromModel].labels });
  const routes = route(fromModel);
  const routeModels = Object.keys(routes);
  routeModels.forEach((toModel) => {
    const fn = routes[toModel];
    convert$1[fromModel][toModel] = wrapRounded(fn);
    convert$1[fromModel][toModel].raw = wrapRaw(fn);
  });
});
var colorConvert = convert$1;
const colorString = colorString$1.exports;
const convert = colorConvert;
const _slice = [].slice;
const skippedModels = [
  "keyword",
  "gray",
  "hex"
];
const hashedModelKeys = {};
for (const model of Object.keys(convert)) {
  hashedModelKeys[_slice.call(convert[model].labels).sort().join("")] = model;
}
const limiters = {};
function Color(object, model) {
  if (!(this instanceof Color)) {
    return new Color(object, model);
  }
  if (model && model in skippedModels) {
    model = null;
  }
  if (model && !(model in convert)) {
    throw new Error("Unknown model: " + model);
  }
  let i;
  let channels;
  if (object == null) {
    this.model = "rgb";
    this.color = [0, 0, 0];
    this.valpha = 1;
  } else if (object instanceof Color) {
    this.model = object.model;
    this.color = object.color.slice();
    this.valpha = object.valpha;
  } else if (typeof object === "string") {
    const result = colorString.get(object);
    if (result === null) {
      throw new Error("Unable to parse color from string: " + object);
    }
    this.model = result.model;
    channels = convert[this.model].channels;
    this.color = result.value.slice(0, channels);
    this.valpha = typeof result.value[channels] === "number" ? result.value[channels] : 1;
  } else if (object.length > 0) {
    this.model = model || "rgb";
    channels = convert[this.model].channels;
    const newArray = _slice.call(object, 0, channels);
    this.color = zeroArray(newArray, channels);
    this.valpha = typeof object[channels] === "number" ? object[channels] : 1;
  } else if (typeof object === "number") {
    this.model = "rgb";
    this.color = [
      object >> 16 & 255,
      object >> 8 & 255,
      object & 255
    ];
    this.valpha = 1;
  } else {
    this.valpha = 1;
    const keys = Object.keys(object);
    if ("alpha" in object) {
      keys.splice(keys.indexOf("alpha"), 1);
      this.valpha = typeof object.alpha === "number" ? object.alpha : 0;
    }
    const hashedKeys = keys.sort().join("");
    if (!(hashedKeys in hashedModelKeys)) {
      throw new Error("Unable to parse color from object: " + JSON.stringify(object));
    }
    this.model = hashedModelKeys[hashedKeys];
    const labels = convert[this.model].labels;
    const color2 = [];
    for (i = 0; i < labels.length; i++) {
      color2.push(object[labels[i]]);
    }
    this.color = zeroArray(color2);
  }
  if (limiters[this.model]) {
    channels = convert[this.model].channels;
    for (i = 0; i < channels; i++) {
      const limit = limiters[this.model][i];
      if (limit) {
        this.color[i] = limit(this.color[i]);
      }
    }
  }
  this.valpha = Math.max(0, Math.min(1, this.valpha));
  if (Object.freeze) {
    Object.freeze(this);
  }
}
Color.prototype = {
  toString() {
    return this.string();
  },
  toJSON() {
    return this[this.model]();
  },
  string(places) {
    let self = this.model in colorString.to ? this : this.rgb();
    self = self.round(typeof places === "number" ? places : 1);
    const args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
    return colorString.to[self.model](args);
  },
  percentString(places) {
    const self = this.rgb().round(typeof places === "number" ? places : 1);
    const args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
    return colorString.to.rgb.percent(args);
  },
  array() {
    return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
  },
  object() {
    const result = {};
    const channels = convert[this.model].channels;
    const labels = convert[this.model].labels;
    for (let i = 0; i < channels; i++) {
      result[labels[i]] = this.color[i];
    }
    if (this.valpha !== 1) {
      result.alpha = this.valpha;
    }
    return result;
  },
  unitArray() {
    const rgb = this.rgb().color;
    rgb[0] /= 255;
    rgb[1] /= 255;
    rgb[2] /= 255;
    if (this.valpha !== 1) {
      rgb.push(this.valpha);
    }
    return rgb;
  },
  unitObject() {
    const rgb = this.rgb().object();
    rgb.r /= 255;
    rgb.g /= 255;
    rgb.b /= 255;
    if (this.valpha !== 1) {
      rgb.alpha = this.valpha;
    }
    return rgb;
  },
  round(places) {
    places = Math.max(places || 0, 0);
    return new Color(this.color.map(roundToPlace(places)).concat(this.valpha), this.model);
  },
  alpha(value) {
    if (arguments.length > 0) {
      return new Color(this.color.concat(Math.max(0, Math.min(1, value))), this.model);
    }
    return this.valpha;
  },
  red: getset("rgb", 0, maxfn(255)),
  green: getset("rgb", 1, maxfn(255)),
  blue: getset("rgb", 2, maxfn(255)),
  hue: getset(["hsl", "hsv", "hsl", "hwb", "hcg"], 0, (value) => (value % 360 + 360) % 360),
  saturationl: getset("hsl", 1, maxfn(100)),
  lightness: getset("hsl", 2, maxfn(100)),
  saturationv: getset("hsv", 1, maxfn(100)),
  value: getset("hsv", 2, maxfn(100)),
  chroma: getset("hcg", 1, maxfn(100)),
  gray: getset("hcg", 2, maxfn(100)),
  white: getset("hwb", 1, maxfn(100)),
  wblack: getset("hwb", 2, maxfn(100)),
  cyan: getset("cmyk", 0, maxfn(100)),
  magenta: getset("cmyk", 1, maxfn(100)),
  yellow: getset("cmyk", 2, maxfn(100)),
  black: getset("cmyk", 3, maxfn(100)),
  x: getset("xyz", 0, maxfn(100)),
  y: getset("xyz", 1, maxfn(100)),
  z: getset("xyz", 2, maxfn(100)),
  l: getset("lab", 0, maxfn(100)),
  a: getset("lab", 1),
  b: getset("lab", 2),
  keyword(value) {
    if (arguments.length > 0) {
      return new Color(value);
    }
    return convert[this.model].keyword(this.color);
  },
  hex(value) {
    if (arguments.length > 0) {
      return new Color(value);
    }
    return colorString.to.hex(this.rgb().round().color);
  },
  hexa(value) {
    if (arguments.length > 0) {
      return new Color(value);
    }
    const rgbArray = this.rgb().round().color;
    let alphaHex = Math.round(this.valpha * 255).toString(16).toUpperCase();
    if (alphaHex.length === 1) {
      alphaHex = "0" + alphaHex;
    }
    return colorString.to.hex(rgbArray) + alphaHex;
  },
  rgbNumber() {
    const rgb = this.rgb().color;
    return (rgb[0] & 255) << 16 | (rgb[1] & 255) << 8 | rgb[2] & 255;
  },
  luminosity() {
    const rgb = this.rgb().color;
    const lum = [];
    for (const [i, element] of rgb.entries()) {
      const chan = element / 255;
      lum[i] = chan <= 0.03928 ? chan / 12.92 : ((chan + 0.055) / 1.055) ** 2.4;
    }
    return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
  },
  contrast(color2) {
    const lum1 = this.luminosity();
    const lum2 = color2.luminosity();
    if (lum1 > lum2) {
      return (lum1 + 0.05) / (lum2 + 0.05);
    }
    return (lum2 + 0.05) / (lum1 + 0.05);
  },
  level(color2) {
    const contrastRatio = this.contrast(color2);
    if (contrastRatio >= 7.1) {
      return "AAA";
    }
    return contrastRatio >= 4.5 ? "AA" : "";
  },
  isDark() {
    const rgb = this.rgb().color;
    const yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1e3;
    return yiq < 128;
  },
  isLight() {
    return !this.isDark();
  },
  negate() {
    const rgb = this.rgb();
    for (let i = 0; i < 3; i++) {
      rgb.color[i] = 255 - rgb.color[i];
    }
    return rgb;
  },
  lighten(ratio) {
    const hsl = this.hsl();
    hsl.color[2] += hsl.color[2] * ratio;
    return hsl;
  },
  darken(ratio) {
    const hsl = this.hsl();
    hsl.color[2] -= hsl.color[2] * ratio;
    return hsl;
  },
  saturate(ratio) {
    const hsl = this.hsl();
    hsl.color[1] += hsl.color[1] * ratio;
    return hsl;
  },
  desaturate(ratio) {
    const hsl = this.hsl();
    hsl.color[1] -= hsl.color[1] * ratio;
    return hsl;
  },
  whiten(ratio) {
    const hwb = this.hwb();
    hwb.color[1] += hwb.color[1] * ratio;
    return hwb;
  },
  blacken(ratio) {
    const hwb = this.hwb();
    hwb.color[2] += hwb.color[2] * ratio;
    return hwb;
  },
  grayscale() {
    const rgb = this.rgb().color;
    const value = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
    return Color.rgb(value, value, value);
  },
  fade(ratio) {
    return this.alpha(this.valpha - this.valpha * ratio);
  },
  opaquer(ratio) {
    return this.alpha(this.valpha + this.valpha * ratio);
  },
  rotate(degrees) {
    const hsl = this.hsl();
    let hue = hsl.color[0];
    hue = (hue + degrees) % 360;
    hue = hue < 0 ? 360 + hue : hue;
    hsl.color[0] = hue;
    return hsl;
  },
  mix(mixinColor, weight) {
    if (!mixinColor || !mixinColor.rgb) {
      throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof mixinColor);
    }
    const color1 = mixinColor.rgb();
    const color2 = this.rgb();
    const p2 = weight === void 0 ? 0.5 : weight;
    const w = 2 * p2 - 1;
    const a = color1.alpha() - color2.alpha();
    const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2;
    const w2 = 1 - w1;
    return Color.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue(), color1.alpha() * p2 + color2.alpha() * (1 - p2));
  }
};
for (const model of Object.keys(convert)) {
  if (skippedModels.includes(model)) {
    continue;
  }
  const channels = convert[model].channels;
  Color.prototype[model] = function() {
    if (this.model === model) {
      return new Color(this);
    }
    if (arguments.length > 0) {
      return new Color(arguments, model);
    }
    const newAlpha = typeof arguments[channels] === "number" ? channels : this.valpha;
    return new Color(assertArray(convert[this.model][model].raw(this.color)).concat(newAlpha), model);
  };
  Color[model] = function(color2) {
    if (typeof color2 === "number") {
      color2 = zeroArray(_slice.call(arguments), channels);
    }
    return new Color(color2, model);
  };
}
function roundTo(number, places) {
  return Number(number.toFixed(places));
}
function roundToPlace(places) {
  return function(number) {
    return roundTo(number, places);
  };
}
function getset(model, channel, modifier) {
  model = Array.isArray(model) ? model : [model];
  for (const m2 of model) {
    (limiters[m2] || (limiters[m2] = []))[channel] = modifier;
  }
  model = model[0];
  return function(value) {
    let result;
    if (arguments.length > 0) {
      if (modifier) {
        value = modifier(value);
      }
      result = this[model]();
      result.color[channel] = value;
      return result;
    }
    result = this[model]().color[channel];
    if (modifier) {
      result = modifier(result);
    }
    return result;
  };
}
function maxfn(max) {
  return function(v) {
    return Math.max(0, Math.min(max, v));
  };
}
function assertArray(value) {
  return Array.isArray(value) ? value : [value];
}
function zeroArray(array, length) {
  for (let i = 0; i < length; i++) {
    if (typeof array[i] !== "number") {
      array[i] = 0;
    }
  }
  return array;
}
var color = Color;
var isMergeableObject = function isMergeableObject2(value) {
  return isNonNullObject(value) && !isSpecial(value);
};
function isNonNullObject(value) {
  return !!value && typeof value === "object";
}
function isSpecial(value) {
  var stringValue = Object.prototype.toString.call(value);
  return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement(value);
}
var canUseSymbol = typeof Symbol === "function" && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 60103;
function isReactElement(value) {
  return value.$$typeof === REACT_ELEMENT_TYPE;
}
function emptyTarget(val) {
  return Array.isArray(val) ? [] : {};
}
function cloneUnlessOtherwiseSpecified(value, options) {
  return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
}
function defaultArrayMerge(target, source, options) {
  return target.concat(source).map(function(element) {
    return cloneUnlessOtherwiseSpecified(element, options);
  });
}
function getMergeFunction(key, options) {
  if (!options.customMerge) {
    return deepmerge;
  }
  var customMerge = options.customMerge(key);
  return typeof customMerge === "function" ? customMerge : deepmerge;
}
function getEnumerableOwnPropertySymbols(target) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
    return target.propertyIsEnumerable(symbol);
  }) : [];
}
function getKeys(target) {
  return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
}
function propertyIsOnObject(object, property) {
  try {
    return property in object;
  } catch (_) {
    return false;
  }
}
function propertyIsUnsafe(target, key) {
  return propertyIsOnObject(target, key) && !(Object.hasOwnProperty.call(target, key) && Object.propertyIsEnumerable.call(target, key));
}
function mergeObject(target, source, options) {
  var destination = {};
  if (options.isMergeableObject(target)) {
    getKeys(target).forEach(function(key) {
      destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
    });
  }
  getKeys(source).forEach(function(key) {
    if (propertyIsUnsafe(target, key)) {
      return;
    }
    if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
      destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
    } else {
      destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
    }
  });
  return destination;
}
function deepmerge(target, source, options) {
  options = options || {};
  options.arrayMerge = options.arrayMerge || defaultArrayMerge;
  options.isMergeableObject = options.isMergeableObject || isMergeableObject;
  options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
  var sourceIsArray = Array.isArray(source);
  var targetIsArray = Array.isArray(target);
  var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
  if (!sourceAndTargetTypesMatch) {
    return cloneUnlessOtherwiseSpecified(source, options);
  } else if (sourceIsArray) {
    return options.arrayMerge(target, source, options);
  } else {
    return mergeObject(target, source, options);
  }
}
deepmerge.all = function deepmergeAll(array, options) {
  if (!Array.isArray(array)) {
    throw new Error("first argument should be an array");
  }
  return array.reduce(function(prev, next) {
    return deepmerge(prev, next, options);
  }, {});
};
var deepmerge_1 = deepmerge;
var cjs = deepmerge_1;
function getLinearRamp(from, to, steps = 1) {
  if (from && from[0] === from[1])
    from = [0, from[1]];
  if (from[0] === from[1])
    from = [0, 1];
  const fromInterpolator = getPositionScale("linear", [0, 1], from);
  const toInterpolator = getPositionScale("linear", [0, 1], to);
  const values = [];
  for (let i = 0; i <= steps; i++) {
    values.push(fromInterpolator(i / steps));
    values.push(toInterpolator(i / steps));
  }
  return values;
}
function getInterpolatedSteps(from, to, steps = 1) {
  if (!from || !Number.isFinite(from[0]) || !Number.isFinite(from[1]))
    from = [0, 1];
  const fromInterpolator = getPositionScale("linear", [0, 1], from);
  const toInterpolator = to;
  const values = [];
  for (let i = 0; i <= steps; i++) {
    values.push(fromInterpolator(i / steps));
    values.push(toInterpolator(i / steps));
  }
  return values;
}
function getStepsFromChunks(chunks) {
  const steps = [];
  chunks.forEach((chunk, i) => {
    if (i === 0)
      steps.push(chunk.color);
    steps.push(chunk.value[0]);
    steps.push(chunk.color);
  });
  return steps;
}
const getComplementaryColor = (color$1) => {
  const c = color(color$1);
  const luminosity = c.luminosity();
  if (luminosity > 0.8)
    return c.darken(0.2).desaturate(0.25).rgb().string();
  if (luminosity > 0.5)
    return c.darken(0.1).desaturate(0.1).rgb().string();
  if (luminosity > 0.25)
    return c.lighten(0.1).rgb().string();
  if (luminosity > 0.1)
    return c.lighten(0.4).rgb().string();
  return c.lightness(40).desaturate(0.25).rgb().string();
};
function getRampExpression(type, varName, steps) {
  if (type === "step")
    return ["step", ["get", varName], ...steps];
  if (type === "linear")
    return ["interpolate", ["linear"], ["get", varName], ...steps];
  throw new Error("no ramp for type: " + type);
}
const getLineWidthExpression = (minWidth, maxWidth, minZoom, maxZoom) => {
  const areAllNumbers = [minZoom, maxZoom, minWidth, maxWidth].every((v) => Number.isFinite(v));
  if (!areAllNumbers)
    return 0;
  if (minWidth === maxWidth)
    return minWidth;
  return [
    "interpolate",
    ["linear"],
    ["zoom"],
    minZoom,
    minWidth,
    maxZoom,
    maxWidth
  ];
};
const getColorExpression = (varName, color2, noDataColor = "transparent") => {
  if (!color2)
    return "transparent";
  return ["case", ["!=", ["get", varName], null], color2, noDataColor];
};
function getCaseExpression(varName, truthyValue, falsyValue) {
  return ["case", ["!=", ["get", varName], null], truthyValue, falsyValue];
}
function getComplementarySteps(steps) {
  return steps.map((step) => {
    if (Number.isFinite(step))
      return step;
    return getComplementaryColor(step);
  });
}
function getChoroplethFillLayer({ varName, fillColor, baseLayer }) {
  return __spreadValues({
    id: `${varName}-fill`,
    type: "fill",
    paint: {
      "fill-color": fillColor
    },
    interactive: true
  }, baseLayer);
}
const getChoroplethOutlineLayer = ({
  varName,
  lineColor,
  lineWidth,
  baseLayer
}) => {
  return __spreadValues({
    id: `${varName}-outline`,
    type: "line",
    paint: {
      "line-color": lineColor,
      "line-width": lineWidth
    }
  }, baseLayer);
};
const getChoroplethHoverLayers = ({
  varName,
  lineColor,
  lineWidth,
  casingColor,
  casingWidth,
  baseLayer
}) => {
  return [
    __spreadValues({
      id: `${varName}-hoverCasing`,
      type: "line",
      paint: {
        "line-color": casingColor,
        "line-width": [
          "case",
          ["boolean", ["feature-state", "hover"], false],
          lineWidth + casingWidth,
          0
        ]
      }
    }, baseLayer),
    __spreadValues({
      id: `${varName}-hoverOutline`,
      type: "line",
      paint: {
        "line-color": lineColor,
        "line-width": [
          "case",
          ["boolean", ["feature-state", "hover"], false],
          lineWidth,
          0
        ]
      }
    }, baseLayer)
  ];
};
function getBubbleFillLayers(context) {
  const {
    rampType,
    varName,
    region_id: region,
    steps,
    zoomBuffer,
    beforeId = "water",
    min_zoom,
    max_zoom,
    autoSwitch
  } = context;
  const fillRule = getRampExpression(rampType, varName, steps);
  const baseLayer = {
    id: `${region}-bubble`,
    source: `${region}`,
    "source-layer": `${region}-centers`,
    type: "circle",
    minzoom: min_zoom,
    maxzoom: max_zoom,
    paint: {
      "circle-color": [
        "case",
        ["!=", ["get", varName], null],
        fillRule,
        "transparent"
      ],
      "fill-opacity": 1
    },
    beforeId,
    interactive: true
  };
  const autoSwitchOverrides = {
    minzoom: min_zoom - zoomBuffer,
    maxzoom: max_zoom + zoomBuffer,
    paint: {
      "fill-opacity": [
        "interpolate",
        ["linear"],
        ["zoom"],
        min_zoom - zoomBuffer,
        0,
        min_zoom,
        1,
        max_zoom,
        1,
        max_zoom + zoomBuffer,
        0
      ]
    }
  };
  return [autoSwitch ? cjs(baseLayer, autoSwitchOverrides) : baseLayer];
}
const getBubbleFillLayer = ({
  varName,
  circleStrokeColor,
  circleStrokeWidth,
  circleColor,
  circleRadius,
  baseLayer
}) => {
  return __spreadValues({
    id: `${varName}-bubble`,
    type: "circle",
    paint: {
      "circle-color": circleColor,
      "circle-radius": circleRadius,
      "circle-stroke-color": circleStrokeColor,
      "circle-stroke-width": circleStrokeWidth
    },
    interactive: true
  }, baseLayer);
};
const getBubbleOutlineLayer = ({
  varName,
  lineColor,
  lineWidth,
  circleRadius,
  baseLayer
}) => {
  return __spreadValues({
    id: `${varName}-outline`,
    type: "circle",
    paint: {
      "circle-color": "transparent",
      "circle-stroke-color": lineColor,
      "circle-stroke-width": lineWidth,
      "circle-radius": circleRadius
    }
  }, baseLayer);
};
function getChoroplethLayers(varName, scale, layerConfig) {
  const {
    source_id,
    source_layer,
    min_zoom,
    max_zoom,
    min_linewidth,
    max_linewidth,
    line_color,
    na_line_color = "#ccc",
    na_fill_color = "#eee",
    hover_color = "#f00",
    hover_linewidth = 2,
    casing_color = "#fff",
    casing_linewidth = 4,
    beforeId,
    outlineBeforeId
  } = layerConfig;
  const baseLayer = (() => {
    const result = { source: source_id };
    if (source_layer)
      result["source-layer"] = source_layer;
    if (min_zoom)
      result["minzoom"] = min_zoom;
    if (max_zoom)
      result["maxzoom"] = max_zoom;
    if (beforeId)
      result["beforeId"] = beforeId;
    return result;
  })();
  const {
    color: color2,
    chunks,
    ScaleProps: { min, max }
  } = scale;
  const extent = [min, max];
  const rampType = chunks ? "step" : "linear";
  const fillSteps = rampType === "step" ? getStepsFromChunks(chunks) : getInterpolatedSteps(extent, color2.copy().domain([0, 1]), 24);
  const fillColorExpression = getRampExpression(rampType, varName, fillSteps);
  const fillColor = getColorExpression(varName, fillColorExpression, na_fill_color);
  const lineColorExpression = line_color === "auto" ? getRampExpression(rampType, varName, getComplementarySteps(fillSteps)) : line_color;
  const lineColor = getColorExpression(varName, lineColorExpression, na_line_color);
  const lineWidth = getLineWidthExpression(min_linewidth, max_linewidth, min_zoom, max_zoom);
  const fillLayer = getChoroplethFillLayer({ varName, fillColor, baseLayer });
  const outlineLayer = getChoroplethOutlineLayer({
    varName,
    lineColor,
    lineWidth,
    baseLayer: outlineBeforeId ? __spreadProps(__spreadValues({}, baseLayer), { beforeId: outlineBeforeId }) : baseLayer
  });
  const hoverLayers = getChoroplethHoverLayers({
    varName,
    lineColor: hover_color,
    lineWidth: hover_linewidth,
    casingColor: casing_color,
    casingWidth: casing_linewidth,
    baseLayer: outlineBeforeId ? __spreadProps(__spreadValues({}, baseLayer), { beforeId: outlineBeforeId }) : baseLayer
  });
  return [fillLayer, outlineLayer, ...hoverLayers];
}
function getBubbleLayers(varName, scale, layerConfig) {
  const {
    source_id,
    source_layer,
    min_zoom,
    max_zoom,
    min_linewidth,
    max_linewidth,
    line_color,
    na_line_color = "#ccc",
    na_fill_color = "#eee",
    min_zoom_size,
    max_zoom_size
  } = layerConfig;
  const baseLayer = (() => {
    const result = { source: source_id };
    if (source_layer)
      result["source-layer"] = source_layer;
    if (min_zoom)
      result["minzoom"] = min_zoom;
    if (max_zoom)
      result["maxzoom"] = max_zoom;
    return result;
  })();
  const {
    color: color2,
    size,
    chunks,
    ScaleProps: { min, max }
  } = scale;
  const extent = [min, max];
  const rampType = "linear";
  [
    "interpolate",
    ["linear"],
    ["get", varName],
    extent[0],
    chunks[0],
    extent[1],
    chunks[chunks.length - 1]
  ];
  const fillSteps = getInterpolatedSteps(extent, color2.copy().domain([0, 1]), 4);
  const fillColorExpression = getRampExpression(rampType, varName, fillSteps);
  const circleColor = getColorExpression(varName, fillColorExpression, na_fill_color);
  const circleRadius = [
    "interpolate",
    ["linear"],
    ["zoom"],
    min_zoom,
    [
      "case",
      ["!=", ["get", varName], null],
      [
        "interpolate",
        ["linear"],
        ["get", varName],
        ...getLinearRamp(extent, min_zoom_size)
      ],
      1
    ],
    max_zoom,
    [
      "case",
      ["!=", ["get", varName], null],
      [
        "interpolate",
        ["linear"],
        ["get", varName],
        ...getLinearRamp(extent, max_zoom_size)
      ],
      6
    ]
  ];
  line_color === "auto" ? getRampExpression(rampType, varName, getComplementarySteps(fillSteps)) : line_color;
  const fillLayer = getBubbleFillLayer({
    varName,
    circleStrokeColor: "#fff",
    circleStrokeWidth: 1,
    circleColor,
    circleRadius,
    baseLayer
  });
  return [fillLayer];
}
function useChoroplethMapLayers({
  context: contextOverrides,
  scale: scaleOverrides,
  createLayer = getChoroplethLayers
} = {}) {
  const accessor = useAccessor();
  const context = useChoroplethContext(contextOverrides);
  const choroplethVarName = accessor(context);
  const choroplethScale = useChoroplethScale({
    context,
    config: scaleOverrides
  });
  const choroplethMapLayerConfig = useMapLayersConfig(context);
  const layers = choroplethMapLayerConfig.map((config) => createLayer(choroplethVarName, choroplethScale, config)).flat();
  return layers;
}
function useBubbleMapLayers({
  context: contextOverrides,
  scale: scaleOverrides,
  createLayer = getBubbleLayers
} = {}) {
  const accessor = useAccessor();
  const context = useBubbleContext(contextOverrides);
  const bubbleVarName = accessor(context);
  const bubbleScale = useBubbleScale({ context, config: scaleOverrides });
  const bubbleMapLayerConfig = useMapLayersConfig(context);
  return bubbleMapLayerConfig.map((config) => createLayer(bubbleVarName, bubbleScale, config)).flat();
}
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === void 0) {
    throw new TypeError("Object.assign cannot be called with null or undefined");
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String("abc");
    test1[5] = "de";
    if (Object.getOwnPropertyNames(test1)[0] === "5") {
      return false;
    }
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2["_" + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
      return test2[n2];
    });
    if (order2.join("") !== "0123456789") {
      return false;
    }
    var test3 = {};
    "abcdefghijklmnopqrst".split("").forEach(function(letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
shouldUseNative() ? Object.assign : function(target, source) {
  var from;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f = require$$0, g = 60103;
reactJsxRuntime_production_min.Fragment = 60107;
if (typeof Symbol === "function" && Symbol.for) {
  var h = Symbol.for;
  g = h("react.element");
  reactJsxRuntime_production_min.Fragment = h("react.fragment");
}
var m = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n = Object.prototype.hasOwnProperty, p = { key: true, ref: true, __self: true, __source: true };
function q(c, a, k) {
  var b, d = {}, e = null, l = null;
  k !== void 0 && (e = "" + k);
  a.key !== void 0 && (e = "" + a.key);
  a.ref !== void 0 && (l = a.ref);
  for (b in a)
    n.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
  if (c && c.defaultProps)
    for (b in a = c.defaultProps, a)
      d[b] === void 0 && (d[b] = a[b]);
  return { $$typeof: g, type: c, key: e, ref: l, props: d, _owner: m.current };
}
reactJsxRuntime_production_min.jsx = q;
reactJsxRuntime_production_min.jsxs = q;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
const jsx = jsxRuntime.exports.jsx;
function Dashboard(_a) {
  var _b = _a, {
    client,
    config,
    loader,
    onLoad,
    children
  } = _b, props = __objRest(_b, [
    "client",
    "config",
    "loader",
    "onLoad",
    "children"
  ]);
  const isReady = useConfigStore((state) => state.ready);
  const onConfigLoad = useOnConfigLoad();
  useConfigLoader({
    config,
    onLoad: onLoad || onConfigLoad
  });
  return /* @__PURE__ */ jsx(QueryClientProvider, __spreadProps(__spreadValues({
    client
  }, props), {
    children: isReady ? children : loader
  }));
}
Dashboard.defaultProps = {
  client: new QueryClient(),
  loader: "loading"
};
Dashboard.propTypes = {
  client: PropTypes.any,
  config: PropTypes.object.isRequired,
  loader: PropTypes.any,
  onLoad: PropTypes.func
};
export { PASS_THROUGH, QueryParamRouter, areEqual, autoFormatNumber, Dashboard as default, fetchDataSource, formatCurrency, formatDate8601, formatDecimal, formatDollars, formatFullCurrency, formatFullDate, formatInteger, formatIntegerShort, formatMonth, formatMonthDay, formatMonthYear, formatNothing, formatOnOff, formatPercent, formatPercentValue, formatShortDate, formatShortMonth, formatYesNo, getAllMatches, getBestMatch, getBlockGroupFromGeoid, getBubbleFillLayer, getBubbleFillLayers, getBubbleLayers, getBubbleOutlineLayer, getCaseExpression, getChoroplethFillLayer, getChoroplethHoverLayers, getChoroplethLayers, getChoroplethOutlineLayer, getCityFromGeoid, getColorExpression, getComplementarySteps, getCountyFromGeoid, getCurrentUrlQueryParams, getDefaultParser, getFormatter, getInterpolatedSteps, getLineWidthExpression, getLinearRamp, getLocationContextFromGeoid, getNextColor, getRampExpression, getRegionFromGeoid, getStateFromGeoid, getStepsFromChunks, getTractFromGeoid, interpolateString, isMatch, loadConfig, loadLanguage, mapParamsToStateValues, mapStateToQueryParams, parseCsvString, parseId, parseJsonData, parseValue, parseValues, reverseVarMap, setUrlQueryParams, useAccessor, useAddLocation, useAppConfig, useBubbleContext, useBubbleMapLayers, useBubbleMetric, useBubbleOptions, useBubbleScale, useChoroplethContext, useChoroplethMapLayers, useChoroplethMetric, useChoroplethOptions, useChoroplethScale, useConfig, useConfigLoader, useConfigStore, useCurrentContext, useCurrentRouteParams, useDashboardState, useDashboardStore, useDataSource, useDataSourceConfig, useLang, useLangObject, useLangStore, useLoadConfig, useLoadLanguage, useLocationData, useLocationFeature, useLocationState, useLocationStore, useMapLayersConfig, useMapSourceConfig, useMapSources, useMetricConfig, useOnConfigLoad, useRegionConfig, useRegionOptions, useRemoveLocation, useRouteStore, useScaleConfig, useSetLanguage, useSubgroupConfig, useSubgroupOptions, useToggleLocation, useToggleSelectedLocation, useYearOptions };
